const categoriesMockAz = {
  categories: [
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
      path: 'elanlar/neqliyyat',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
      __typename: 'Category',
      description:
        'Avtomobillər, ehtiyat hissələri, aksesuarlar, avtobuslar və tikinti texnikası ',
      name: 'Nəqliyyat',
      count: 88868,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mg',
          path: 'elanlar/neqliyyat/avtomobiller',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Avtomobillər',
          count: 6809,
          hasAutogeneratedTitle: true,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mw',
          path: 'elanlar/neqliyyat/ehtiyyat-hisseleri-ve-aksesuarlar',
          count: 76562,
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Ehtiyat hissələri və aksesuarlar',
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4NA',
          path: 'elanlar/neqliyyat/su-neqliyyati',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Su nəqliyyatı',
          count: 141,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4NQ',
          path: 'elanlar/neqliyyat/motosikletler-mopedler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Motosikletlər və mopedlər',
          count: 1307,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Ng',
          path: 'elanlar/neqliyyat/tikinti-texnikasi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Tikinti texnikası',
          count: 1359,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Nw',
          path: 'elanlar/neqliyyat/aqrotexnika',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Aqrotexnika',
          count: 764,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMw',
          path: 'elanlar/neqliyyat/avtobuslar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Avtobuslar',
          count: 31,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNA',
          path: 'elanlar/neqliyyat/yuk-masinlari-ve-qosqular',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Yük maşınları və qoşqular',
          count: 848,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcxMQ',
          path: 'elanlar/neqliyyat/qeydiyyat-nisanlari',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Qeydiyyat nişanları',
          count: 1047,
          hasAutogeneratedTitle: false,
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
      path: 'elanlar/elektronika',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
      __typename: 'Category',
      description:
        'Audio və video, kompüter aksesuarları, telefonlar, noutbuklar, netbuklar, masaüstü kompüterlər, foto avadanlıqlar, planşetlər, elektron kitablar, komponentlər, monitorlar',
      name: 'Elektronika',
      count: 86255,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMQ',
          name: 'Audio və video',
          path: 'elanlar/elektronika/audio-video',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 7023,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMg',
          name: 'Kompüter aksesuarları',
          path: 'elanlar/elektronika/komputer-aksesuarlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 6134,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMw',
          name: 'Oyunlar, pultlar və proqramlar',
          path: 'elanlar/elektronika/oyunlar-ve-programlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 6084,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNA',
          name: 'Masaüstü kompüterlər',
          path: 'elanlar/elektronika/komputerler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2639,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNQ',
          name: 'Komponentlər və monitorlar',
          path: 'elanlar/elektronika/komputer-avadanliqi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 8221,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNg',
          name: 'Planşet və elektron kitablar',
          path: 'elanlar/elektronika/plansetler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2740,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNw',
          name: 'Noutbuklar və netbuklar',
          path: 'elanlar/elektronika/noutbuklar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 8854,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOA',
          name: 'Ofis avadanlığı və istehlak materialları',
          path: 'elanlar/elektronika/ofis-avadanliqi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 3127,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOQ',
          name: 'Telefonlar',
          path: 'elanlar/elektronika/telefonlar',
          count: 22170,
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          hasAutogeneratedTitle: true,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMA',
          name: 'Fototexnika',
          path: 'elanlar/elektronika/fotoaparatlar-ve-linzalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 3154,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzOQ',
          name: 'Nömrələr və SIM-kartlar',
          path: 'elanlar/elektronika/nomreler-ve-sim-kartlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 3224,
          hasAutogeneratedTitle: true,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5MA',
          name: 'Smart saat və qolbaqlar',
          path: 'elanlar/elektronika/smart-saat-ve-qolbaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 3003,
          hasAutogeneratedTitle: true,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5MQ',
          name: 'Televizorlar və aksesuarlar',
          path: 'elanlar/elektronika/televizor-ve-aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 5493,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNw',
          name: 'Şəbəkə və server avadanlığı',
          path: 'elanlar/elektronika/sebeke-avadanligi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 4389,
          hasAutogeneratedTitle: false,
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
      path: 'elanlar/ev-ve-bag-ucun',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
      __typename: 'Category',
      description:
        'Təmir və tikinti, mebel və interyer, məişət texnikası, qab-qacaq və mətbəx ləvazimatları, bitkilər',
      name: 'Ev və bağ üçün',
      count: 84122,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4OA',
          name: 'Təmir və tikinti',
          path: 'elanlar/ev-ve-bag-ucun/temir-tikinti',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 16599,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4OQ',
          name: 'Mebellər',
          path: 'elanlar/ev-ve-bag-ucun/mebel',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 22335,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MA',
          name: 'Məişət texnikası',
          path: 'elanlar/ev-ve-bag-ucun/meiset-texnikasi',
          count: 21076,
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MQ',
          name: 'Qab-qacaq və mətbəx ləvazimatları',
          path: 'elanlar/ev-ve-bag-ucun/qab-qacaq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 6591,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mg',
          name: 'Bitkilər',
          path: 'elanlar/ev-ve-bag-ucun/bitkiler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1787,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzMw',
          name: 'Ərzaq',
          path: 'elanlar/ev-ve-bag-ucun/erzaq',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1053,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Mg',
          name: 'Xalçalar və aksesuarlar',
          path: 'elanlar/ev-ve-bag-ucun/xalcalar-aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1786,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Mw',
          name: 'Ev tekstili',
          path: 'elanlar/ev-ve-bag-ucun/ev-tekstili',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2470,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5NA',
          name: 'Ev və bağ üçün işiqlandırma',
          path: 'elanlar/ev-ve-bag-ucun/ev-bag-ucun-ishiqlandirma',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2523,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5NQ',
          name: 'Dekor və interyer',
          path: 'elanlar/ev-ve-bag-ucun/dekor-interyer',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 3832,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Ng',
          name: 'Bağ və bostan',
          path: 'elanlar/ev-ve-bag-ucun/bag-bostan',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2927,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNQ',
          name: 'Ev təsərrüfatı malları',
          path: 'elanlar/ev-ve-bag-ucun/ev-teserrufati-mallari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1143,
          hasAutogeneratedTitle: false,
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mw',
      path: 'elanlar/neqliyyat/ehtiyyat-hisseleri-ve-aksesuarlar',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F07%2F16%2F15%2F51%2F52%2F7df05b75-36e0-4ef8-a7c3-fa0b785ae9c1%2F12183_ogtQftp0VNM0b8HrfrDIcQ.png',
      __typename: 'Category',
      description: 'Avtomobillər üçün aksesuarlar və ehtiyat hissələri',
      name: 'Ehtiyat hissələri və aksesuarlar',
      children: [],
      count: 76562,
      propertyOptions: [
        {
          name: 'Aksesuarlar',
          count: 10325,
          legacyResourceId: '4045',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Audio və video texnika',
          count: 2779,
          legacyResourceId: '4046',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Avto kosmetika və kimya',
          count: 898,
          legacyResourceId: '4044',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Avtomobil üçün alətlər',
          count: 917,
          legacyResourceId: '42255',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Diaqnostika cihazları',
          count: 371,
          legacyResourceId: '7693',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Ehtiyat hissələri',
          count: 50187,
          legacyResourceId: '4047',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'GPS-naviqatorlar',
          count: 77,
          legacyResourceId: '4043',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Şinlər, disklər və təkərlər',
          count: 10095,
          legacyResourceId: '4050',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Siqnalizasiyalar',
          count: 38,
          legacyResourceId: '4048',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Videoqeydiyyatçılar',
          count: 575,
          legacyResourceId: '7476',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Digər',
          count: 300,
          legacyResourceId: '4051',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
      ],
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
        name: 'Nəqliyyat',
        count: 88868,
        path: 'elanlar/neqliyyat',
        icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
        __typename: 'Category',
      },
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
      path: 'elanlar/dasinmaz-emlak',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
      __typename: 'Category',
      description:
        'Mənzillər, həyət və bağ evləri, torpaq sahələri, obyektlər, ofislər, qarajlar, xaricdə daşınmaz əmlak',
      name: 'Daşınmaz əmlak',
      count: 45685,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMQ',
          name: 'Həyət evləri, bağ evləri',
          path: 'elanlar/dasinmaz-emlak/heyet-evleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 14648,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMg',
          name: 'Torpaq',
          path: 'elanlar/dasinmaz-emlak/torpaq-sahesi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 6484,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMw',
          name: 'Qarajlar',
          path: 'elanlar/dasinmaz-emlak/qarajlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 150,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNA',
          name: 'Xaricdə əmlak',
          path: 'elanlar/dasinmaz-emlak/xaricde-emlak',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 93,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNQ',
          name: 'Obyektlər və ofislər',
          path: 'elanlar/dasinmaz-emlak/obyektler-ve-ofisler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4356,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNQ',
          name: 'Mənzillər',
          path: 'elanlar/dasinmaz-emlak/menziller',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 19954,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
      path: 'elanlar/xidmetler',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
      __typename: 'Category',
      description:
        'Avadanlıqların icarəsi və quraşdırılması, təmir və tikinti, təhlükəsizlik sistemləri, reklam, dizayn, avadanlıqların təmiri, mebellərin yığılması, tərcümə, təlim, hazırlıq kursları, IT, internet, musiqi, əyləncə',
      name: 'Xidmətlər və biznes',
      count: 34750,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Nw',
          name: 'Avadanlıqların quraşdırılması',
          path: 'elanlar/xidmetler/avadanliqin-qurasdirilmasi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 264,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1OA',
          name: 'Avadanlığın icarəsi',
          path: 'elanlar/xidmetler/avadanliqin-icaresi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 628,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1OQ',
          name: 'Digər',
          path: 'elanlar/xidmetler/diger-xidmetler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 347,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2MA',
          name: 'Təlim, hazırlıq kursları',
          path: 'elanlar/xidmetler/telim-hazirliq-kurslari',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 638,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2MQ',
          name: 'Tibbi xidmətlər',
          path: 'elanlar/xidmetler/tibbi-xidmetler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 81,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Mg',
          name: 'Musiqi, əyləncə və tədbirlər',
          path: 'elanlar/xidmetler/tedbirlerin-teskilati',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 154,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Mw',
          name: 'Dayələr, baxıcılar',
          path: 'elanlar/xidmetler/dayeler-baxicilar',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 88,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2NA',
          name: 'Tərcümə',
          path: 'elanlar/xidmetler/tercume-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 46,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2NQ',
          name: 'Reklam, dizayn və poliqrafiya',
          path: 'elanlar/xidmetler/reklam-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 573,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Ng',
          name: 'Təmir və tikinti',
          path: 'elanlar/xidmetler/temir-tikinti',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 3778,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Nw',
          name: 'Texnika təmiri',
          path: 'elanlar/xidmetler/texnika-temiri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1099,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2OA',
          name: 'Mebel yığılması və təmiri',
          path: 'elanlar/xidmetler/sifarisle-mebel',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 319,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2OQ',
          name: 'Nəqliyyat vasitələrinin icarəsi',
          path: 'elanlar/xidmetler/neqliyyat-icaresi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1068,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3MA',
          name: 'Təmizlik',
          path: 'elanlar/xidmetler/temizlik-xidmeti',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 242,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3MQ',
          name: 'Təhlükəsizlik sistemləri',
          path: 'elanlar/xidmetler/tehlukesizlik-sistemleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 5983,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Mg',
          name: 'Hüquq xidmətləri',
          path: 'elanlar/xidmetler/huquq-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 40,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Mw',
          name: 'IT, internet, telekom',
          path: 'elanlar/xidmetler/komputer-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 454,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3NA',
          name: 'Gözəllik, sağlamlıq',
          path: 'elanlar/xidmetler/gozellik-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 93,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3NQ',
          name: 'Foto və video çəkiliş xidmətləri',
          path: 'elanlar/xidmetler/foto-ve-video-cekilis',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 117,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Ng',
          name: 'Sığorta xidmətləri',
          path: 'elanlar/xidmetler/sigorta-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 17,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Nw',
          name: 'Qidalanma, keyterinq',
          path: 'elanlar/xidmetler/keyterinq-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 112,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3OA',
          name: 'Mühasibat xidmətləri',
          path: 'elanlar/xidmetler/muhasibat-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 124,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4MQ',
          name: 'Avtoservis və diaqnostika ',
          path: 'elanlar/xidmetler/avtoservis-ve-diaqnostika',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 304,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzMQ',
          name: 'Biznes üçün avadanlıq',
          path: 'elanlar/xidmetler/biznes-avadanligi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 17616,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNg',
          name: 'Logistika',
          path: 'elanlar/xidmetler/logistika',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 565,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
      path: 'elanlar/sexsi-esyalar',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
      __typename: 'Category',
      description: 'Geyim və ayaqqabılar, aksesuarlar, saat və zinət əşyaları',
      name: 'Şəxsi əşyalar',
      count: 31146,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNw',
          name: 'Geyim və ayaqqabılar',
          path: 'elanlar/sexsi-esyalar/geyim-ayaqqabilar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 13441,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwOA',
          name: 'Aksesuarlar',
          path: 'elanlar/sexsi-esyalar/aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4313,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNg',
          name: 'Saat və zinət əşyaları',
          path: 'elanlar/sexsi-esyalar/saatlar-zinet-esyalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 5497,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzOA',
          name: 'Sağlamlıq və gözəllik',
          path: 'elanlar/sexsi-esyalar/gozellik-saglamliq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 7138,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0Mw',
          name: 'İtmiş əşyalar',
          path: 'elanlar/sexsi-esyalar/itmis-esyalar',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 34,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5OA',
          name: 'Elektron siqaretlər və tütün qızdırıcıları',
          path: 'elanlar/sexsi-esyalar/elektron-siqaretler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 723,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
      path: 'elanlar/hobbi-ve-asude',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
      __typename: 'Category',
      description:
        'Biletlər və səyahət, velosipedlər, kolleksiya, idman və asudə, musiqi alətləri, kitablar və jurnallar, tanışlıq',
      name: 'Hobbi və asudə',
      count: 23413,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMg',
          name: 'Biletlər və səyahət',
          path: 'elanlar/hobbi-ve-asude/turlar-ve-biletler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 122,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMw',
          name: 'Velosipedlər',
          path: 'elanlar/hobbi-ve-asude/velosipedler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4369,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNA',
          name: 'Kolleksiyalar',
          path: 'elanlar/hobbi-ve-asude/kolleksiyalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 3420,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNQ',
          name: 'Musiqi alətləri',
          path: 'elanlar/hobbi-ve-asude/musiqi-aletleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4190,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNg',
          name: 'İdman və asudə',
          path: 'elanlar/hobbi-ve-asude/idman-ve-asude',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 7028,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNw',
          name: 'Kitab və jurnallar',
          path: 'elanlar/hobbi-ve-asude/kitab-ve-jurnallar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2137,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOA',
          name: 'Kempinq, ovçuluq və balıqçılıq',
          path: 'elanlar/hobbi-ve-asude/kempinq-ovculuq-baliqciliq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1907,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNw',
          name: 'Tanışlıq',
          path: 'elanlar/hobbi-ve-asude/tanisliq',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 240,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOQ',
      path: 'elanlar/elektronika/telefonlar',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F12%2F05%2F17%2F04%2F59%2F8fecaa9e-ac94-4edc-9a70-ddc6239b6e02%2F67900_VsfyEqu9G0cxtdUTwCN1tQ.png',
      __typename: 'Category',
      description: 'Telefonlar, smartfonlar və aksesuarlar elanları',
      name: 'Telefonlar',
      children: [],
      count: 22170,
      propertyOptions: [
        {
          name: 'Acer',
          count: 0,
          legacyResourceId: '3851',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Aiek',
          count: 3,
          legacyResourceId: '7368',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Aksesuarlar',
          count: 4552,
          legacyResourceId: '3864',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Alcatel',
          count: 9,
          legacyResourceId: '3852',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Apple iPhone',
          count: 6950,
          legacyResourceId: '3855',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Asus',
          count: 8,
          legacyResourceId: '4180',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Blackberry',
          count: 27,
          legacyResourceId: '3853',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Blackview',
          count: 17,
          legacyResourceId: '45625',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Cubot',
          count: 9,
          legacyResourceId: '45610',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Doogee',
          count: 3,
          legacyResourceId: '7369',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Dublikat',
          count: 183,
          legacyResourceId: '4188',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Ehtiyat hissələri',
          count: 1113,
          legacyResourceId: '7448',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Ericsson',
          count: 6,
          legacyResourceId: '7375',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Fly',
          count: 11,
          legacyResourceId: '7364',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Google',
          count: 27,
          legacyResourceId: '38821',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Hisense',
          count: 4,
          legacyResourceId: '7541',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Hoffmann',
          count: 2,
          legacyResourceId: '7567',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Homtom',
          count: 0,
          legacyResourceId: '7372',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Honor',
          count: 639,
          legacyResourceId: '10108',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Hope',
          count: 152,
          legacyResourceId: '22438',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Hotwav',
          count: 12,
          legacyResourceId: '44928',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'HTC',
          count: 8,
          legacyResourceId: '3854',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Huawei',
          count: 113,
          legacyResourceId: '4118',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Infinix ',
          count: 246,
          legacyResourceId: '39354',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'INOI',
          count: 30,
          legacyResourceId: '43821',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Itel',
          count: 9,
          legacyResourceId: '37014',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Jinga',
          count: 3,
          legacyResourceId: '7619',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Keneksi',
          count: 3,
          legacyResourceId: '7374',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Kgtel',
          count: 30,
          legacyResourceId: '22326',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Leagoo',
          count: 1,
          legacyResourceId: '7569',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Lenovo',
          count: 9,
          legacyResourceId: '4126',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'LG',
          count: 7,
          legacyResourceId: '3856',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Meizu',
          count: 2,
          legacyResourceId: '7366',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Micromax',
          count: 1,
          legacyResourceId: '7542',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Motorola',
          count: 66,
          legacyResourceId: '3857',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Nokia',
          count: 643,
          legacyResourceId: '3858',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'OnePlus',
          count: 16,
          legacyResourceId: '7371',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'OPPO',
          count: 92,
          legacyResourceId: '38970',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Oukitel',
          count: 29,
          legacyResourceId: '7568',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Philips',
          count: 6,
          legacyResourceId: '3859',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Realme',
          count: 80,
          legacyResourceId: '21150',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Samsung',
          count: 3608,
          legacyResourceId: '3860',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Siemens',
          count: 6,
          legacyResourceId: '3861',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Sony',
          count: 11,
          legacyResourceId: '3862',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Sony Ericsson',
          count: 11,
          legacyResourceId: '7362',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'SOYES',
          count: 19,
          legacyResourceId: '46134',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Stasionar telefonlar',
          count: 331,
          legacyResourceId: '3866',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'TCL',
          count: 2,
          legacyResourceId: '36868',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Tecno',
          count: 120,
          legacyResourceId: '36154',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Thuraya ',
          count: 0,
          legacyResourceId: '46308',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Umi',
          count: 0,
          legacyResourceId: '7373',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Vertu',
          count: 88,
          legacyResourceId: '3863',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Vivo',
          count: 24,
          legacyResourceId: '43728',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'X-Inova',
          count: 32,
          legacyResourceId: '44861',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Xiaomi',
          count: 2587,
          legacyResourceId: '7367',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'XOR',
          count: 12,
          legacyResourceId: '44106',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'ZTE',
          count: 23,
          legacyResourceId: '7370',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Digər',
          count: 175,
          legacyResourceId: '3867',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
      ],
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
        name: 'Elektronika',
        count: 86255,
        path: 'elanlar/elektronika',
        icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
        __typename: 'Category',
      },
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MA',
      path: 'elanlar/ev-ve-bag-ucun/meiset-texnikasi',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2025%2F04%2F28%2F16%2F08%2F43%2F9d45f947-f695-4725-a7b8-fc991f6fa843%2F27314_nl5hK4zSmPDP2ykAjfmWfg.png',
      __typename: 'Category',
      description: 'Eviniz üçün məişət texnikası',
      name: 'Məişət texnikası',
      children: [],
      count: 21076,
      propertyOptions: [
        {
          name: 'Aspiratorlar',
          count: 418,
          legacyResourceId: '7657',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Blenderlər, mikserlər, mətbəx kombaynları',
          count: 808,
          legacyResourceId: '7629',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Blinçik və vafli aparatı',
          count: 69,
          legacyResourceId: '34686',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Elektrik çaydanlar və termopotlar',
          count: 463,
          legacyResourceId: '7628',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Elektrik samovarlar',
          count: 238,
          legacyResourceId: '7687',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Ətçəkən maşınlar',
          count: 328,
          legacyResourceId: '7632',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Fritürlar',
          count: 235,
          legacyResourceId: '34671',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Hava nəmləndiriciləri və təmizləyiciləri',
          count: 161,
          legacyResourceId: '38103',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Kondisionerlər',
          count: 1810,
          legacyResourceId: '3895',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Mikrodalğalı sobalar',
          count: 364,
          legacyResourceId: '3891',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Mini sobalar',
          count: 328,
          legacyResourceId: '34629',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Multibişiricilər',
          count: 159,
          legacyResourceId: '34728',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Paltarqurudanlar',
          count: 90,
          legacyResourceId: '45547',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Paltaryuyanlar',
          count: 2237,
          legacyResourceId: '3889',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Plitələr',
          count: 1414,
          legacyResourceId: '3892',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Qabyuyanlar',
          count: 395,
          legacyResourceId: '3893',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Qəhvədəmləyənlər və qəhvə maşınları',
          count: 573,
          legacyResourceId: '7633',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Qızdırıcılar',
          count: 925,
          legacyResourceId: '3896',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Quraşdırılan sobalar',
          count: 413,
          legacyResourceId: '34628',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Samovarlar',
          count: 412,
          legacyResourceId: '7686',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Sərinkeşlər',
          count: 301,
          legacyResourceId: '34725',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Şirəçəkənlər',
          count: 325,
          legacyResourceId: '7634',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Soyuducular',
          count: 3484,
          legacyResourceId: '3894',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Su dispenserləri və kulerləri',
          count: 152,
          legacyResourceId: '34627',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Su filtrləri və pompaları',
          count: 564,
          legacyResourceId: '34621',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Süd separatorları',
          count: 52,
          legacyResourceId: '34727',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Termometrlər',
          count: 227,
          legacyResourceId: '34669',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Tərəzilər',
          count: 216,
          legacyResourceId: '34685',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Tikiş maşınları',
          count: 789,
          legacyResourceId: '7631',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Tosterlər və çörəkbişirənlər',
          count: 343,
          legacyResourceId: '7630',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Tozsoranlar',
          count: 1742,
          legacyResourceId: '3888',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Ütülər',
          count: 565,
          legacyResourceId: '3890',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Vakuum paketləyicilər',
          count: 104,
          legacyResourceId: '34684',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Digər',
          count: 372,
          legacyResourceId: '3898',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
      ],
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
        name: 'Ev və bağ üçün',
        count: 84122,
        path: 'elanlar/ev-ve-bag-ucun',
        icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
        __typename: 'Category',
      },
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
      path: 'elanlar/usaqlar-ucun',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
      __typename: 'Category',
      description:
        'Avtomobil oturacaqları, oyuncaqlar, uşaq arabaları və avtomobillər, uşaq geyimləri, mebellər, məktəblilər üçün və s.',
      name: 'Uşaq aləmi',
      count: 16422,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OQ',
          name: 'Avtomobil oturacaqları',
          path: 'elanlar/usaqlar-ucun/avtomobil-oturacaqlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 304,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1MA',
          name: 'Oyuncaqlar',
          path: 'elanlar/usaqlar-ucun/oyuncaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2875,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1MQ',
          name: 'Uşaq arabaları',
          path: 'elanlar/usaqlar-ucun/usaq-arabalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1911,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Mg',
          name: 'Uşaq geyimi',
          path: 'elanlar/usaqlar-ucun/usaq-geyimleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2394,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Mw',
          name: 'Uşaq mebeli',
          path: 'elanlar/usaqlar-ucun/mebel',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 637,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1NA',
          name: 'Uşaq qidası və bəslənməsi',
          path: 'elanlar/usaqlar-ucun/usaq-yemekleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 217,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1NQ',
          name: 'Digər',
          path: 'elanlar/usaqlar-ucun/her-sey',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 53,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3OQ',
          name: 'Məktəblilər üçün',
          path: 'elanlar/usaqlar-ucun/mekteb-levazimatlari',
          count: 2898,
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4MA',
          name: 'Yürütəclər',
          path: 'elanlar/usaqlar-ucun/yurutecler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 298,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Mg',
          name: 'Manejlər',
          path: 'elanlar/usaqlar-ucun/manejler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 187,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Mw',
          name: 'Çarpayılar və beşiklər',
          path: 'elanlar/usaqlar-ucun/usaq-carpayilari-ve-beshikler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2176,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4NA',
          name: 'Qidalanma oturacaqları',
          path: 'elanlar/usaqlar-ucun/qidalanma-ucun-usaq-oturacaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 618,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4NQ',
          name: 'Sürüşkənlər və meydançalar',
          path: 'elanlar/usaqlar-ucun/usaq-suruskenleri-ve-oyun-meydancalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 221,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Ng',
          name: 'Uşaq daşıyıcıları',
          path: 'elanlar/usaqlar-ucun/usaq-dasiyicilari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 204,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Nw',
          name: 'Uşaq avtomobilləri',
          path: 'elanlar/usaqlar-ucun/usaq-avtomobilleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1082,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwOA',
          name: 'Hamam və gigiyena',
          path: 'elanlar/usaqlar-ucun/usaq-gigiyenasi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 198,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwOQ',
          name: 'Uşaq tekstili',
          path: 'elanlar/usaqlar-ucun/usaq-tekstili',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 149,
          hasAutogeneratedTitle: false,
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
      path: 'elanlar/heyvanlar',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
      __typename: 'Category',
      description: 'İtlər, pişiklər, quşlar, balıqlar və digər heyvanlar',
      name: 'Heyvanlar',
      count: 9652,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5NA',
          name: 'İtlər',
          path: 'elanlar/heyvanlar/itler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1872,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5NQ',
          name: 'Pişiklər',
          path: 'elanlar/heyvanlar/pisikler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1182,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Ng',
          name: 'Quşlar',
          path: 'elanlar/heyvanlar/quslar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 2564,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Nw',
          name: 'Akvariumlar və balıqlar',
          path: 'elanlar/heyvanlar/baliqlar-akvariumlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1204,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OA',
          name: 'Digər heyvanlar',
          path: 'elanlar/heyvanlar/diger-heyvanlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 68,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMA',
          name: 'Heyvanlar üçün məhsullar və yemlər',
          path: 'elanlar/heyvanlar/heyvanlar-ucun-mehsullar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1909,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5OQ',
          name: 'K/t heyvanları',
          path: 'elanlar/heyvanlar/kt-heyvanlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 621,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMA',
          name: 'Dovşanlar',
          path: 'elanlar/heyvanlar/dovsanlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 116,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMQ',
          name: 'Atlar',
          path: 'elanlar/heyvanlar/atlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 61,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMg',
          name: 'Gəmiricilər',
          path: 'elanlar/heyvanlar/gemiriciler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 55,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
      path: 'elanlar/is-elanlari',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
      __typename: 'Category',
      description: 'Vakansiyalar, iş axtarıram',
      name: 'İş elanları',
      count: 9551,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4OA',
          name: 'Vakansiyalar',
          path: 'elanlar/is-elanlari/vakansiyalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 6690,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
            name: 'İş elanları',
            count: 9551,
            path: 'elanlar/is-elanlari',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4OQ',
          name: 'İş axtarıram',
          path: 'elanlar/is-elanlari/is-axtariram',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 2861,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
            name: 'İş elanları',
            count: 9551,
            path: 'elanlar/is-elanlari',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3OQ',
      path: 'elanlar/usaqlar-ucun/mekteb-levazimatlari',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F09%2F05%2F12%2F49%2F53%2Ff002ff11-9888-4a76-b438-252fe86f6914%2F11375_qXr7-N1ppBcS2a5TEaxWRQ.png',
      __typename: 'Category',
      description: 'Dəftərxana ləvazimatları, dərsliklər, məktəbli çantları',
      name: 'Məktəblilər üçün',
      children: [],
      count: 2898,
      propertyOptions: [
        {
          name: 'Dəftərxana ləvazimatları',
          count: 217,
          legacyResourceId: '7658',
          parentLegacyId: null,
          propertyLegacyId: '845',
          __typename: 'PropertyOption',
        },
        {
          name: 'Dərsliklər',
          count: 2021,
          legacyResourceId: '7662',
          parentLegacyId: null,
          propertyLegacyId: '845',
          __typename: 'PropertyOption',
        },
        {
          name: 'Məktəbli çantaları',
          count: 303,
          legacyResourceId: '7659',
          parentLegacyId: null,
          propertyLegacyId: '845',
          __typename: 'PropertyOption',
        },
        {
          name: 'Məktəbli forması',
          count: 82,
          legacyResourceId: '7660',
          parentLegacyId: null,
          propertyLegacyId: '845',
          __typename: 'PropertyOption',
        },
        {
          name: 'Yaradıcılıq ləvazimatları',
          count: 275,
          legacyResourceId: '7661',
          parentLegacyId: null,
          propertyLegacyId: '845',
          __typename: 'PropertyOption',
        },
      ],
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
        name: 'Uşaq aləmi',
        count: 16422,
        path: 'elanlar/usaqlar-ucun',
        icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
        __typename: 'Category',
      },
    },
  ],
};

const categoriesMockRu = {
  categories: [
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
      path: 'elanlar/neqliyyat',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
      __typename: 'Category',
      description:
        'Автомобили, автозапчасти, аксессуары, автобусы и строительная техника',
      name: 'Транспорт',
      count: 88868,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mg',
          path: 'elanlar/neqliyyat/avtomobiller',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Легковые автомобили',
          count: 6809,
          hasAutogeneratedTitle: true,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mw',
          path: 'elanlar/neqliyyat/ehtiyyat-hisseleri-ve-aksesuarlar',
          count: 76562,
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Автозапчасти и аксессуары',
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4NA',
          path: 'elanlar/neqliyyat/su-neqliyyati',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Водный транспорт',
          count: 141,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4NQ',
          path: 'elanlar/neqliyyat/motosikletler-mopedler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Мотоциклы и мопеды',
          count: 1307,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Ng',
          path: 'elanlar/neqliyyat/tikinti-texnikasi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Строительная техника',
          count: 1359,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Nw',
          path: 'elanlar/neqliyyat/aqrotexnika',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Агротехника',
          count: 764,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMw',
          path: 'elanlar/neqliyyat/avtobuslar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Автобусы',
          count: 31,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNA',
          path: 'elanlar/neqliyyat/yuk-masinlari-ve-qosqular',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Грузовики и прицепы',
          count: 848,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcxMQ',
          path: 'elanlar/neqliyyat/qeydiyyat-nisanlari',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 88868,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          name: 'Регистрационные номера',
          count: 1047,
          hasAutogeneratedTitle: false,
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
      path: 'elanlar/elektronika',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
      __typename: 'Category',
      description:
        'Аудио и видео, компьютерные аксессуары, телефоны, ноутбуки, нетбуки, настольные компьютеры, фототехника, планшеты, электронные книги, комплектующие, мониторы',
      name: 'Электроника',
      count: 86255,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMQ',
          name: 'Аудио и видео',
          path: 'elanlar/elektronika/audio-video',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 7023,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMg',
          name: 'Компьютерные аксессуары',
          path: 'elanlar/elektronika/komputer-aksesuarlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 6134,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMw',
          name: 'Игры, приставки и программы',
          path: 'elanlar/elektronika/oyunlar-ve-programlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 6084,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNA',
          name: 'Настольные компьютеры',
          path: 'elanlar/elektronika/komputerler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2639,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNQ',
          name: 'Комплектующие и мониторы',
          path: 'elanlar/elektronika/komputer-avadanliqi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 8221,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNg',
          name: 'Планшеты и электронные книги',
          path: 'elanlar/elektronika/plansetler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2740,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNw',
          name: 'Ноутбуки и нетбуки',
          path: 'elanlar/elektronika/noutbuklar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 8854,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOA',
          name: 'Оргтехника и расходники',
          path: 'elanlar/elektronika/ofis-avadanliqi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 3127,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOQ',
          name: 'Мобильные телефоны',
          path: 'elanlar/elektronika/telefonlar',
          count: 22170,
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          hasAutogeneratedTitle: true,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMA',
          name: 'Фототехника',
          path: 'elanlar/elektronika/fotoaparatlar-ve-linzalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 3154,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzOQ',
          name: 'Номера и SIM-карты',
          path: 'elanlar/elektronika/nomreler-ve-sim-kartlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 3224,
          hasAutogeneratedTitle: true,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5MA',
          name: 'Смарт часы и браслеты',
          path: 'elanlar/elektronika/smart-saat-ve-qolbaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 3003,
          hasAutogeneratedTitle: true,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5MQ',
          name: 'Телевизоры и аксессуары',
          path: 'elanlar/elektronika/televizor-ve-aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 5493,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNw',
          name: 'Сетевое и серверное оборудование',
          path: 'elanlar/elektronika/sebeke-avadanligi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 86255,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 4389,
          hasAutogeneratedTitle: false,
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
      path: 'elanlar/ev-ve-bag-ucun',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
      __typename: 'Category',
      description:
        'Ремонт и строительство, мебель и интерьер, бытовая техника, посуда и товары для кухни, растения',
      name: 'Для дома и дачи',
      count: 84122,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4OA',
          name: 'Ремонт и строительство',
          path: 'elanlar/ev-ve-bag-ucun/temir-tikinti',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 16599,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4OQ',
          name: 'Мебель',
          path: 'elanlar/ev-ve-bag-ucun/mebel',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 22335,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MA',
          name: 'Бытовая техника',
          path: 'elanlar/ev-ve-bag-ucun/meiset-texnikasi',
          count: 21076,
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MQ',
          name: 'Посуда и кухонные товары',
          path: 'elanlar/ev-ve-bag-ucun/qab-qacaq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 6591,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mg',
          name: 'Растения',
          path: 'elanlar/ev-ve-bag-ucun/bitkiler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1787,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzMw',
          name: 'Продукты питания',
          path: 'elanlar/ev-ve-bag-ucun/erzaq',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1053,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Mg',
          name: 'Ковры и аксессуары',
          path: 'elanlar/ev-ve-bag-ucun/xalcalar-aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1786,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Mw',
          name: 'Домашний текстиль',
          path: 'elanlar/ev-ve-bag-ucun/ev-tekstili',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2470,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5NA',
          name: 'Освещение для дома и дачи',
          path: 'elanlar/ev-ve-bag-ucun/ev-bag-ucun-ishiqlandirma',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2523,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5NQ',
          name: 'Декор и интерьер',
          path: 'elanlar/ev-ve-bag-ucun/dekor-interyer',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 3832,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Ng',
          name: 'Дача и сад',
          path: 'elanlar/ev-ve-bag-ucun/bag-bostan',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2927,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNQ',
          name: 'Хозяйственные товары',
          path: 'elanlar/ev-ve-bag-ucun/ev-teserrufati-mallari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 84122,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1143,
          hasAutogeneratedTitle: false,
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mw',
      path: 'elanlar/neqliyyat/ehtiyyat-hisseleri-ve-aksesuarlar',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F07%2F16%2F15%2F51%2F52%2F7df05b75-36e0-4ef8-a7c3-fa0b785ae9c1%2F12183_ogtQftp0VNM0b8HrfrDIcQ.png',
      __typename: 'Category',
      description: 'Аксессуары и запчасти для автомобилей',
      name: 'Автозапчасти и аксессуары',
      children: [],
      count: 76562,
      propertyOptions: [
        {
          name: 'Аксессуары',
          count: 10325,
          legacyResourceId: '4045',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Аудио и видеотехника',
          count: 2779,
          legacyResourceId: '4046',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Автокосметика и автохимия',
          count: 898,
          legacyResourceId: '4044',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Автоинструменты',
          count: 917,
          legacyResourceId: '42255',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Диагностические приборы',
          count: 371,
          legacyResourceId: '7693',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Запчасти',
          count: 50187,
          legacyResourceId: '4047',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'GPS-навигаторы',
          count: 77,
          legacyResourceId: '4043',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Шины, диски и колёса',
          count: 10095,
          legacyResourceId: '4050',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Противоугонные устройства',
          count: 38,
          legacyResourceId: '4048',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Видеорегистраторы',
          count: 575,
          legacyResourceId: '7476',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
        {
          name: 'Другое',
          count: 300,
          legacyResourceId: '4051',
          parentLegacyId: null,
          propertyLegacyId: '798',
          __typename: 'PropertyOption',
        },
      ],
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
        name: 'Транспорт',
        count: 88868,
        path: 'elanlar/neqliyyat',
        icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
        __typename: 'Category',
      },
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
      path: 'elanlar/dasinmaz-emlak',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
      __typename: 'Category',
      description:
        'Квартиры, дома, дачи, коттеджи, земельные участки, объекты, офисы, гаражи, недвижимость за рубежом',
      name: 'Недвижимость',
      count: 45685,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMQ',
          name: 'Дома, дачи, коттеджи',
          path: 'elanlar/dasinmaz-emlak/heyet-evleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 14648,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMg',
          name: 'Земельные участки',
          path: 'elanlar/dasinmaz-emlak/torpaq-sahesi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 6484,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMw',
          name: 'Гаражи',
          path: 'elanlar/dasinmaz-emlak/qarajlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 150,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNA',
          name: 'Недвижимость за рубежом',
          path: 'elanlar/dasinmaz-emlak/xaricde-emlak',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 93,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNQ',
          name: 'Объекты и офисы',
          path: 'elanlar/dasinmaz-emlak/obyektler-ve-ofisler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4356,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNQ',
          name: 'Квартиры',
          path: 'elanlar/dasinmaz-emlak/menziller',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 19954,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 45685,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
      path: 'elanlar/xidmetler',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
      __typename: 'Category',
      description:
        'Аренда и установка оборудования, ремонт и строительство, системы безопасности, реклама, дизайн и полиграфия, ремонт оборудования, сборка и реставрация мебели, переводы, обучение, подготовительные курсы, IT, интернет, музыка, развлечения',
      name: 'Услуги и бизнес',
      count: 34750,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Nw',
          name: 'Установка оборудования',
          path: 'elanlar/xidmetler/avadanliqin-qurasdirilmasi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 264,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1OA',
          name: 'Аренда оборудования',
          path: 'elanlar/xidmetler/avadanliqin-icaresi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 628,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1OQ',
          name: 'Другое',
          path: 'elanlar/xidmetler/diger-xidmetler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 347,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2MA',
          name: 'Обучение и курсы',
          path: 'elanlar/xidmetler/telim-hazirliq-kurslari',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 638,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2MQ',
          name: 'Медицинские услуги',
          path: 'elanlar/xidmetler/tibbi-xidmetler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 81,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Mg',
          name: 'Музыка и мероприятия',
          path: 'elanlar/xidmetler/tedbirlerin-teskilati',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 154,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Mw',
          name: 'Няни, сиделки',
          path: 'elanlar/xidmetler/dayeler-baxicilar',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 88,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2NA',
          name: 'Перевод',
          path: 'elanlar/xidmetler/tercume-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 46,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2NQ',
          name: 'Реклама, дизайн и полиграфия',
          path: 'elanlar/xidmetler/reklam-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 573,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Ng',
          name: 'Ремонт и строительство',
          path: 'elanlar/xidmetler/temir-tikinti',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 3778,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Nw',
          name: 'Ремонт техники',
          path: 'elanlar/xidmetler/texnika-temiri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1099,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2OA',
          name: 'Сборка и ремонт мебели',
          path: 'elanlar/xidmetler/sifarisle-mebel',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 319,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2OQ',
          name: 'Аренда транспорта',
          path: 'elanlar/xidmetler/neqliyyat-icaresi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1068,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3MA',
          name: 'Уборка',
          path: 'elanlar/xidmetler/temizlik-xidmeti',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 242,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3MQ',
          name: 'Системы безопасности',
          path: 'elanlar/xidmetler/tehlukesizlik-sistemleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 5983,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Mg',
          name: 'Юридические услуги',
          path: 'elanlar/xidmetler/huquq-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 40,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Mw',
          name: 'IT, интернет, телеком',
          path: 'elanlar/xidmetler/komputer-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 454,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3NA',
          name: 'Красота, здоровье',
          path: 'elanlar/xidmetler/gozellik-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 93,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3NQ',
          name: 'Фото и видеосъёмка',
          path: 'elanlar/xidmetler/foto-ve-video-cekilis',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 117,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Ng',
          name: 'Страхование',
          path: 'elanlar/xidmetler/sigorta-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 17,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Nw',
          name: 'Питание, кейтеринг',
          path: 'elanlar/xidmetler/keyterinq-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 112,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3OA',
          name: 'Бухгалтерские услуги',
          path: 'elanlar/xidmetler/muhasibat-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 124,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4MQ',
          name: 'Автосервис и диагностика',
          path: 'elanlar/xidmetler/avtoservis-ve-diaqnostika',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 304,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzMQ',
          name: 'Оборудование для бизнеса',
          path: 'elanlar/xidmetler/biznes-avadanligi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 17616,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNg',
          name: 'Логистика',
          path: 'elanlar/xidmetler/logistika',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 565,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 34750,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
      path: 'elanlar/sexsi-esyalar',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
      __typename: 'Category',
      description:
        'Одежда и обувь, часы и украшения, красота и здоровье, аксессуары',
      name: 'Личные вещи',
      count: 31146,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNw',
          name: 'Одежда и обувь',
          path: 'elanlar/sexsi-esyalar/geyim-ayaqqabilar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 13441,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwOA',
          name: 'Аксессуары',
          path: 'elanlar/sexsi-esyalar/aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4313,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNg',
          name: 'Часы и украшения',
          path: 'elanlar/sexsi-esyalar/saatlar-zinet-esyalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 5497,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzOA',
          name: 'Красота и здоровье',
          path: 'elanlar/sexsi-esyalar/gozellik-saglamliq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 7138,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0Mw',
          name: 'Утерянные вещи',
          path: 'elanlar/sexsi-esyalar/itmis-esyalar',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 34,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5OA',
          name: 'Электронные сигареты и системы нагревания табака',
          path: 'elanlar/sexsi-esyalar/elektron-siqaretler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 723,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 31146,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
      path: 'elanlar/hobbi-ve-asude',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
      __typename: 'Category',
      description:
        'Билеты и путешествия, велосипеды, коллекционирование, спорт и отдых, музыкальные инструменты, книги и журналы, знакомства, охота и рыбалка',
      name: 'Хобби и отдых',
      count: 23413,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMg',
          name: 'Билеты и путешествия',
          path: 'elanlar/hobbi-ve-asude/turlar-ve-biletler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 122,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMw',
          name: 'Велосипеды',
          path: 'elanlar/hobbi-ve-asude/velosipedler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4369,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNA',
          name: 'Коллекции',
          path: 'elanlar/hobbi-ve-asude/kolleksiyalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 3420,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNQ',
          name: 'Музыкальные инструменты',
          path: 'elanlar/hobbi-ve-asude/musiqi-aletleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4190,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNg',
          name: 'Спорт и отдых',
          path: 'elanlar/hobbi-ve-asude/idman-ve-asude',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 7028,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNw',
          name: 'Книги и журналы',
          path: 'elanlar/hobbi-ve-asude/kitab-ve-jurnallar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2137,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOA',
          name: 'Кемпинг, охота и рыбалка',
          path: 'elanlar/hobbi-ve-asude/kempinq-ovculuq-baliqciliq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1907,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNw',
          name: 'Знакомства',
          path: 'elanlar/hobbi-ve-asude/tanisliq',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 240,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 23413,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOQ',
      path: 'elanlar/elektronika/telefonlar',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F12%2F05%2F17%2F04%2F59%2F8fecaa9e-ac94-4edc-9a70-ddc6239b6e02%2F67900_VsfyEqu9G0cxtdUTwCN1tQ.png',
      __typename: 'Category',
      description: 'Мобильные телефоны',
      name: 'Мобильные телефоны',
      children: [],
      count: 22170,
      propertyOptions: [
        {
          name: 'Acer',
          count: 0,
          legacyResourceId: '3851',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Aiek',
          count: 3,
          legacyResourceId: '7368',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Аксессуары',
          count: 4552,
          legacyResourceId: '3864',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Alcatel',
          count: 9,
          legacyResourceId: '3852',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Apple iPhone',
          count: 6950,
          legacyResourceId: '3855',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Asus',
          count: 8,
          legacyResourceId: '4180',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Blackberry',
          count: 27,
          legacyResourceId: '3853',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Blackview',
          count: 17,
          legacyResourceId: '45625',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Cubot',
          count: 9,
          legacyResourceId: '45610',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Doogee',
          count: 3,
          legacyResourceId: '7369',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Дубликат',
          count: 183,
          legacyResourceId: '4188',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Запчасти',
          count: 1113,
          legacyResourceId: '7448',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Ericsson',
          count: 6,
          legacyResourceId: '7375',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Fly',
          count: 11,
          legacyResourceId: '7364',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Google',
          count: 27,
          legacyResourceId: '38821',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Hisense',
          count: 4,
          legacyResourceId: '7541',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Hoffmann',
          count: 2,
          legacyResourceId: '7567',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Homtom',
          count: 0,
          legacyResourceId: '7372',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Honor',
          count: 639,
          legacyResourceId: '10108',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Hope',
          count: 152,
          legacyResourceId: '22438',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Hotwav',
          count: 12,
          legacyResourceId: '44928',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'HTC',
          count: 8,
          legacyResourceId: '3854',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Huawei',
          count: 113,
          legacyResourceId: '4118',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Infinix ',
          count: 246,
          legacyResourceId: '39354',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'INOI',
          count: 30,
          legacyResourceId: '43821',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Itel',
          count: 9,
          legacyResourceId: '37014',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Jinga',
          count: 3,
          legacyResourceId: '7619',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Keneksi',
          count: 3,
          legacyResourceId: '7374',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Kgtel',
          count: 30,
          legacyResourceId: '22326',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Leagoo',
          count: 1,
          legacyResourceId: '7569',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Lenovo',
          count: 9,
          legacyResourceId: '4126',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'LG',
          count: 7,
          legacyResourceId: '3856',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Meizu',
          count: 2,
          legacyResourceId: '7366',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Micromax',
          count: 1,
          legacyResourceId: '7542',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Motorola',
          count: 66,
          legacyResourceId: '3857',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Nokia',
          count: 643,
          legacyResourceId: '3858',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'OnePlus',
          count: 16,
          legacyResourceId: '7371',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'OPPO',
          count: 92,
          legacyResourceId: '38970',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Oukitel',
          count: 29,
          legacyResourceId: '7568',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Philips',
          count: 6,
          legacyResourceId: '3859',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Realme',
          count: 80,
          legacyResourceId: '21150',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Samsung',
          count: 3608,
          legacyResourceId: '3860',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Siemens',
          count: 6,
          legacyResourceId: '3861',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Sony',
          count: 11,
          legacyResourceId: '3862',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Sony Ericsson',
          count: 11,
          legacyResourceId: '7362',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'SOYES',
          count: 19,
          legacyResourceId: '46134',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Стационарные телефоны',
          count: 331,
          legacyResourceId: '3866',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'TCL',
          count: 2,
          legacyResourceId: '36868',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Tecno',
          count: 120,
          legacyResourceId: '36154',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Thuraya ',
          count: 0,
          legacyResourceId: '46308',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Umi',
          count: 0,
          legacyResourceId: '7373',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Vertu',
          count: 88,
          legacyResourceId: '3863',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Vivo',
          count: 24,
          legacyResourceId: '43728',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'X-Inova',
          count: 32,
          legacyResourceId: '44861',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Xiaomi',
          count: 2587,
          legacyResourceId: '7367',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'XOR',
          count: 12,
          legacyResourceId: '44106',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'ZTE',
          count: 23,
          legacyResourceId: '7370',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
        {
          name: 'Другое',
          count: 175,
          legacyResourceId: '3867',
          parentLegacyId: null,
          propertyLegacyId: '749',
          __typename: 'PropertyOption',
        },
      ],
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
        name: 'Электроника',
        count: 86255,
        path: 'elanlar/elektronika',
        icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
        __typename: 'Category',
      },
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MA',
      path: 'elanlar/ev-ve-bag-ucun/meiset-texnikasi',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2025%2F04%2F28%2F16%2F08%2F43%2F9d45f947-f695-4725-a7b8-fc991f6fa843%2F27314_nl5hK4zSmPDP2ykAjfmWfg.png',
      __typename: 'Category',
      description: 'Бытовая техника для вашего дома',
      name: 'Бытовая техника',
      children: [],
      count: 21076,
      propertyOptions: [
        {
          name: 'Аспираторы ',
          count: 418,
          legacyResourceId: '7657',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Блендеры, миксеры, кухонные комбайны',
          count: 808,
          legacyResourceId: '7629',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Блинницы и вафельницы',
          count: 69,
          legacyResourceId: '34686',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Электрочайники и термопоты',
          count: 463,
          legacyResourceId: '7628',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Электрические самовары',
          count: 238,
          legacyResourceId: '7687',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Мясорубки',
          count: 328,
          legacyResourceId: '7632',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Фритюрницы',
          count: 235,
          legacyResourceId: '34671',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Увлажнители и очистители воздуха',
          count: 161,
          legacyResourceId: '38103',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Кондиционеры',
          count: 1810,
          legacyResourceId: '3895',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Микроволновые печи',
          count: 364,
          legacyResourceId: '3891',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Мини-печи',
          count: 328,
          legacyResourceId: '34629',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Мультиварки',
          count: 159,
          legacyResourceId: '34728',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Сушильные машины',
          count: 90,
          legacyResourceId: '45547',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Стиральные машины',
          count: 2237,
          legacyResourceId: '3889',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Плиты',
          count: 1414,
          legacyResourceId: '3892',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Посудомоечные машины',
          count: 395,
          legacyResourceId: '3893',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Кофеварки и кофемашины',
          count: 573,
          legacyResourceId: '7633',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Обогреватели',
          count: 925,
          legacyResourceId: '3896',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Духовые шкафы',
          count: 413,
          legacyResourceId: '34628',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Самовары',
          count: 412,
          legacyResourceId: '7686',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Вентиляторы',
          count: 301,
          legacyResourceId: '34725',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Соковыжималки',
          count: 325,
          legacyResourceId: '7634',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Холодильники',
          count: 3484,
          legacyResourceId: '3894',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Диспенсеры и кулеры для воды',
          count: 152,
          legacyResourceId: '34627',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Фильтры и помпы для воды',
          count: 564,
          legacyResourceId: '34621',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Сепараторы для молока',
          count: 52,
          legacyResourceId: '34727',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Термометры',
          count: 227,
          legacyResourceId: '34669',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Весы',
          count: 216,
          legacyResourceId: '34685',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Швейные машины',
          count: 789,
          legacyResourceId: '7631',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Тостеры и хлебопечи',
          count: 343,
          legacyResourceId: '7630',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Пылесосы',
          count: 1742,
          legacyResourceId: '3888',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Утюги',
          count: 565,
          legacyResourceId: '3890',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Вакуумные упаковщики',
          count: 104,
          legacyResourceId: '34684',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
        {
          name: 'Другие',
          count: 372,
          legacyResourceId: '3898',
          parentLegacyId: null,
          propertyLegacyId: '756',
          __typename: 'PropertyOption',
        },
      ],
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
        name: 'Для дома и дачи',
        count: 84122,
        path: 'elanlar/ev-ve-bag-ucun',
        icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
        __typename: 'Category',
      },
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
      path: 'elanlar/usaqlar-ucun',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
      __typename: 'Category',
      description:
        'Автокресла, игрушки, коляски и автомобили, детская одежда, мебель, продукты питания, товары для школьников и многое другое',
      name: 'Детский мир',
      count: 16422,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OQ',
          name: 'Автокресла',
          path: 'elanlar/usaqlar-ucun/avtomobil-oturacaqlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 304,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1MA',
          name: 'Игрушки',
          path: 'elanlar/usaqlar-ucun/oyuncaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2875,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1MQ',
          name: 'Детские коляски',
          path: 'elanlar/usaqlar-ucun/usaq-arabalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1911,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Mg',
          name: 'Детская одежда',
          path: 'elanlar/usaqlar-ucun/usaq-geyimleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2394,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Mw',
          name: 'Детская мебель',
          path: 'elanlar/usaqlar-ucun/mebel',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 637,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1NA',
          name: 'Питание и кормление',
          path: 'elanlar/usaqlar-ucun/usaq-yemekleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 217,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1NQ',
          name: 'Другое',
          path: 'elanlar/usaqlar-ucun/her-sey',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 53,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3OQ',
          name: 'Для школьников',
          path: 'elanlar/usaqlar-ucun/mekteb-levazimatlari',
          count: 2898,
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4MA',
          name: 'Xодунки',
          path: 'elanlar/usaqlar-ucun/yurutecler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 298,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Mg',
          name: 'Манежи',
          path: 'elanlar/usaqlar-ucun/manejler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 187,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Mw',
          name: 'Кроватки и колыбели',
          path: 'elanlar/usaqlar-ucun/usaq-carpayilari-ve-beshikler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 2176,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4NA',
          name: 'Сиденья для кормления',
          path: 'elanlar/usaqlar-ucun/qidalanma-ucun-usaq-oturacaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 618,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4NQ',
          name: 'Горки и площадки',
          path: 'elanlar/usaqlar-ucun/usaq-suruskenleri-ve-oyun-meydancalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 221,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Ng',
          name: 'Детские переноски',
          path: 'elanlar/usaqlar-ucun/usaq-dasiyicilari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 204,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Nw',
          name: 'Детские автомобили',
          path: 'elanlar/usaqlar-ucun/usaq-avtomobilleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 1082,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwOA',
          name: 'Купание и гигиена',
          path: 'elanlar/usaqlar-ucun/usaq-gigiyenasi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 198,
          hasAutogeneratedTitle: false,
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwOQ',
          name: 'Детский текстиль',
          path: 'elanlar/usaqlar-ucun/usaq-tekstili',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 16422,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
          __typename: 'Category',
          count: 149,
          hasAutogeneratedTitle: false,
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
      path: 'elanlar/heyvanlar',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
      __typename: 'Category',
      description: 'Собаки, кошки, птицы, рыбы и другие животные ',
      name: 'Животные',
      count: 9652,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5NA',
          name: 'Собаки',
          path: 'elanlar/heyvanlar/itler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1872,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5NQ',
          name: 'Кошки',
          path: 'elanlar/heyvanlar/pisikler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1182,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Ng',
          name: 'Птицы',
          path: 'elanlar/heyvanlar/quslar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 2564,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Nw',
          name: 'Аквариумы и рыбы',
          path: 'elanlar/heyvanlar/baliqlar-akvariumlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1204,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OA',
          name: 'Другие животные',
          path: 'elanlar/heyvanlar/diger-heyvanlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 68,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMA',
          name: 'Товары для животных',
          path: 'elanlar/heyvanlar/heyvanlar-ucun-mehsullar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1909,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5OQ',
          name: 'С/Х животные',
          path: 'elanlar/heyvanlar/kt-heyvanlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 621,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMA',
          name: 'Кролики',
          path: 'elanlar/heyvanlar/dovsanlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 116,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMQ',
          name: 'Лошади',
          path: 'elanlar/heyvanlar/atlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 61,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMg',
          name: 'Грызуны',
          path: 'elanlar/heyvanlar/gemiriciler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 55,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 9652,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
      path: 'elanlar/is-elanlari',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
      __typename: 'Category',
      description: 'Вакансии, ищу работу',
      name: 'Работа',
      count: 9551,
      propertyOptions: null,
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 429864,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4OA',
          name: 'Вакансии',
          path: 'elanlar/is-elanlari/vakansiyalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 6690,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
            name: 'Работа',
            count: 9551,
            path: 'elanlar/is-elanlari',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4OQ',
          name: 'Ищу работу',
          path: 'elanlar/is-elanlari/is-axtariram',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 2861,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
            name: 'Работа',
            count: 9551,
            path: 'elanlar/is-elanlari',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3OQ',
      path: 'elanlar/usaqlar-ucun/mekteb-levazimatlari',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F09%2F05%2F12%2F49%2F53%2Ff002ff11-9888-4a76-b438-252fe86f6914%2F11375_qXr7-N1ppBcS2a5TEaxWRQ.png',
      __typename: 'Category',
      description: 'Канцелярские товары, учебники, рюкзаки, школьная форма',
      name: 'Для школьников',
      children: [],
      count: 2898,
      propertyOptions: [
        {
          name: 'Канцелярские товары',
          count: 217,
          legacyResourceId: '7658',
          parentLegacyId: null,
          propertyLegacyId: '845',
          __typename: 'PropertyOption',
        },
        {
          name: 'Учебники',
          count: 2021,
          legacyResourceId: '7662',
          parentLegacyId: null,
          propertyLegacyId: '845',
          __typename: 'PropertyOption',
        },
        {
          name: 'Ранцы, рюкзаки, сумки',
          count: 303,
          legacyResourceId: '7659',
          parentLegacyId: null,
          propertyLegacyId: '845',
          __typename: 'PropertyOption',
        },
        {
          name: 'Школьная форма',
          count: 82,
          legacyResourceId: '7660',
          parentLegacyId: null,
          propertyLegacyId: '845',
          __typename: 'PropertyOption',
        },
        {
          name: 'Товары для творчества',
          count: 275,
          legacyResourceId: '7661',
          parentLegacyId: null,
          propertyLegacyId: '845',
          __typename: 'PropertyOption',
        },
      ],
      parent: {
        isPriceRequired: true,
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
        name: 'Детский мир',
        count: 16422,
        path: 'elanlar/usaqlar-ucun',
        icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
        __typename: 'Category',
      },
    },
  ],
};

const rootCategoriesMockAz = {
  categories: [
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
      name: 'Elektronika',
      path: 'elanlar/elektronika',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
      name: 'Nəqliyyat',
      path: 'elanlar/neqliyyat',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
      name: 'Daşınmaz əmlak',
      path: 'elanlar/dasinmaz-emlak',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
      name: 'Ev və bağ üçün',
      path: 'elanlar/ev-ve-bag-ucun',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mw',
      name: 'Ehtiyat hissələri və aksesuarlar',
      path: 'elanlar/neqliyyat/ehtiyyat-hisseleri-ve-aksesuarlar',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F07%2F16%2F15%2F51%2F52%2F7df05b75-36e0-4ef8-a7c3-fa0b785ae9c1%2F12183_ogtQftp0VNM0b8HrfrDIcQ.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOQ',
      name: 'Telefonlar',
      path: 'elanlar/elektronika/telefonlar',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F12%2F05%2F17%2F04%2F59%2F8fecaa9e-ac94-4edc-9a70-ddc6239b6e02%2F67900_VsfyEqu9G0cxtdUTwCN1tQ.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
      name: 'Xidmətlər və biznes',
      path: 'elanlar/xidmetler',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
      name: 'Şəxsi əşyalar',
      path: 'elanlar/sexsi-esyalar',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
      name: 'Hobbi və asudə',
      path: 'elanlar/hobbi-ve-asude',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MA',
      name: 'Məişət texnikası',
      path: 'elanlar/ev-ve-bag-ucun/meiset-texnikasi',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F12%2F05%2F15%2F06%2F21%2F0ec2af6c-0768-4565-8ace-6916db612e3a%2F67900_VsfyEqu9G0cxtdUTwCN1tQ.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
      name: 'İş elanları',
      path: 'elanlar/is-elanlari',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
      name: 'Heyvanlar',
      path: 'elanlar/heyvanlar',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
      name: 'Uşaq aləmi',
      path: 'elanlar/usaqlar-ucun',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Ng',
      name: 'Təmir və tikinti',
      path: 'elanlar/xidmetler/temir-tikinti',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2025%2F02%2F10%2F16%2F59%2F18%2Ff1006921-b3d7-4153-a336-d3f68ade685f%2F1957_PTAk9XsjQ8he6mTnwxv8JQ.png',
      description: '',
      __typename: 'Category',
    },
  ],
};

export const rootCategoriesMockRu = {
  categories: [
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
      name: 'Электроника',
      path: 'elanlar/elektronika',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
      name: 'Транспорт',
      path: 'elanlar/neqliyyat',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
      name: 'Недвижимость',
      path: 'elanlar/dasinmaz-emlak',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
      name: 'Для дома и дачи',
      path: 'elanlar/ev-ve-bag-ucun',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mw',
      name: 'Автозапчасти и аксессуары',
      path: 'elanlar/neqliyyat/ehtiyyat-hisseleri-ve-aksesuarlar',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F07%2F16%2F15%2F51%2F52%2F7df05b75-36e0-4ef8-a7c3-fa0b785ae9c1%2F12183_ogtQftp0VNM0b8HrfrDIcQ.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOQ',
      name: 'Мобильные телефоны',
      path: 'elanlar/elektronika/telefonlar',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F12%2F05%2F17%2F04%2F59%2F8fecaa9e-ac94-4edc-9a70-ddc6239b6e02%2F67900_VsfyEqu9G0cxtdUTwCN1tQ.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
      name: 'Услуги и бизнес',
      path: 'elanlar/xidmetler',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
      name: 'Личные вещи',
      path: 'elanlar/sexsi-esyalar',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
      name: 'Хобби и отдых',
      path: 'elanlar/hobbi-ve-asude',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MA',
      name: 'Бытовая техника',
      path: 'elanlar/ev-ve-bag-ucun/meiset-texnikasi',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2024%2F12%2F05%2F15%2F06%2F21%2F0ec2af6c-0768-4565-8ace-6916db612e3a%2F67900_VsfyEqu9G0cxtdUTwCN1tQ.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
      name: 'Работа',
      path: 'elanlar/is-elanlari',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
      name: 'Животные',
      path: 'elanlar/heyvanlar',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
      name: 'Детский мир',
      path: 'elanlar/usaqlar-ucun',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
      description: '',
      __typename: 'Category',
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Ng',
      name: 'Ремонт и строительство',
      path: 'elanlar/xidmetler/temir-tikinti',
      icon: 'https://tap.azstatic.com/uploads/f200x200/2025%2F02%2F10%2F16%2F59%2F18%2Ff1006921-b3d7-4153-a336-d3f68ade685f%2F1957_PTAk9XsjQ8he6mTnwxv8JQ.png',
      description: '',
      __typename: 'Category',
    },
  ],
};

const createAdCategoriesMockRu = {
  categories: [
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
      name: 'Детский мир',
      path: 'elanlar/usaqlar-ucun',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
      __typename: 'Category',
      description:
        'Автокресла, игрушки, детские коляски и автомобили, детская одежда, мебель, питание, для школьников и другое',
      count: 5033,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OQ',
          name: 'Автокресла',
          path: 'elanlar/usaqlar-ucun/avtomobil-oturacaqlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 125,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1MA',
          name: 'Игрушки',
          path: 'elanlar/usaqlar-ucun/oyuncaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 720,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1MQ',
          name: 'Детские коляски',
          path: 'elanlar/usaqlar-ucun/usaq-arabalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 922,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Nw',
          name: 'Детские автомобили',
          path: 'elanlar/usaqlar-ucun/usaq-avtomobilleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 337,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Mw',
          name: 'Кроватки и колыбели',
          path: 'elanlar/usaqlar-ucun/usaq-carpayilari-ve-beshikler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 889,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Ng',
          name: 'Детские переноски',
          path: 'elanlar/usaqlar-ucun/usaq-dasiyicilari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 60,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Mg',
          name: 'Детская одежда',
          path: 'elanlar/usaqlar-ucun/usaq-geyimleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 579,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Mw',
          name: 'Детская мебель',
          path: 'elanlar/usaqlar-ucun/mebel',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 273,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1NA',
          name: 'Питание и кормление',
          path: 'elanlar/usaqlar-ucun/usaq-yemekleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 52,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4NQ',
          name: 'Горки и площадки',
          path: 'elanlar/usaqlar-ucun/usaq-suruskenleri-ve-oyun-meydancalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 65,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Mg',
          name: 'Манежи',
          path: 'elanlar/usaqlar-ucun/manejler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 45,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3OQ',
          name: 'Для школьников',
          path: 'elanlar/usaqlar-ucun/mekteb-levazimatlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 536,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4MA',
          name: 'Xодунки',
          path: 'elanlar/usaqlar-ucun/yurutecler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 106,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwOA',
          name: 'Купание и гигиена',
          path: 'elanlar/usaqlar-ucun/usaq-gigiyenasi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 62,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwOQ',
          name: 'Детский текстиль',
          path: 'elanlar/usaqlar-ucun/usaq-tekstili',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 32,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4NA',
          name: 'Сиденья для кормления',
          path: 'elanlar/usaqlar-ucun/qidalanma-ucun-usaq-oturacaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 214,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1NQ',
          name: 'Другое',
          path: 'elanlar/usaqlar-ucun/her-sey',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 16,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Детский мир',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
      name: 'Личные вещи',
      path: 'elanlar/sexsi-esyalar',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
      __typename: 'Category',
      description:
        'Одежда и обувь, часы и украшения, аксессуары, красота и здоровье, утерянные вещи',
      count: 8465,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNw',
          name: 'Одежда и обувь',
          path: 'elanlar/sexsi-esyalar/geyim-ayaqqabilar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 3632,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNg',
          name: 'Часы и украшения',
          path: 'elanlar/sexsi-esyalar/saatlar-zinet-esyalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1675,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwOA',
          name: 'Аксессуары',
          path: 'elanlar/sexsi-esyalar/aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1118,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwOQ',
          name: 'Товары для детей и игрушки',
          path: 'elanlar/sexsi-esyalar/baby-products-and-toys',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 0,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzOA',
          name: 'Красота и здоровье',
          path: 'elanlar/sexsi-esyalar/gozellik-saglamliq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1630,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0Mw',
          name: 'Утерянные вещи',
          path: 'elanlar/sexsi-esyalar/itmis-esyalar',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 30,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5OA',
          name: 'Электронные сигареты и системы нагревания табака',
          path: 'elanlar/sexsi-esyalar/elektron-siqaretler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 380,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Личные вещи',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
      name: 'Для дома и дачи',
      path: 'elanlar/ev-ve-bag-ucun',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
      __typename: 'Category',
      description:
        'Ремонт и строительство, мебель и интерьер, бытовая техника, посуда и товары для кухни, растения',
      count: 25103,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4OA',
          name: 'Ремонт и строительство',
          path: 'elanlar/ev-ve-bag-ucun/temir-tikinti',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4756,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4OQ',
          name: 'Мебель',
          path: 'elanlar/ev-ve-bag-ucun/mebel',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 7544,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MA',
          name: 'Бытовая техника',
          path: 'elanlar/ev-ve-bag-ucun/meiset-texnikasi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 6621,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MQ',
          name: 'Посуда и кухонные товары',
          path: 'elanlar/ev-ve-bag-ucun/qab-qacaq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1691,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzMw',
          name: 'Продукты питания',
          path: 'elanlar/ev-ve-bag-ucun/erzaq',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 276,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mg',
          name: 'Растения',
          path: 'elanlar/ev-ve-bag-ucun/bitkiler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 575,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Mg',
          name: 'Ковры и аксессуары',
          path: 'elanlar/ev-ve-bag-ucun/xalcalar-aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 594,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Mw',
          name: 'Домашний текстиль',
          path: 'elanlar/ev-ve-bag-ucun/ev-tekstili',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 439,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5NA',
          name: 'Освещение для дома и дачи',
          path: 'elanlar/ev-ve-bag-ucun/ev-bag-ucun-ishiqlandirma',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 609,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5NQ',
          name: 'Декор и интерьер',
          path: 'elanlar/ev-ve-bag-ucun/dekor-interyer',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 936,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Ng',
          name: 'Дача и сад',
          path: 'elanlar/ev-ve-bag-ucun/bag-bostan',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 849,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNQ',
          name: 'Хозяйственные товары',
          path: 'elanlar/ev-ve-bag-ucun/ev-teserrufati-mallari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 213,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Для дома и дачи',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
      name: 'Электроника',
      path: 'elanlar/elektronika',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
      __typename: 'Category',
      description:
        'Аудио и видео, компьютерные аксессуары, телефоны, ноутбуки, нетбуки, настольные компьютеры, фототехника, планшеты, электронные книги, комплектующие, мониторы, игры, приставки, программы, номера и SIM-карты, оргтехника и расходники',
      count: 28479,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMQ',
          name: 'Аудио и видео',
          path: 'elanlar/elektronika/audio-video',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1632,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMg',
          name: 'Компьютерные аксессуары',
          path: 'elanlar/elektronika/komputer-aksesuarlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 907,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMw',
          name: 'Игры, приставки и программы',
          path: 'elanlar/elektronika/oyunlar-ve-programlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2098,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNA',
          name: 'Настольные компьютеры',
          path: 'elanlar/elektronika/komputerler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 814,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNQ',
          name: 'Комплектующие и мониторы',
          path: 'elanlar/elektronika/komputer-avadanliqi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1902,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNg',
          name: 'Планшеты и электронные книги',
          path: 'elanlar/elektronika/plansetler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 724,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNw',
          name: 'Ноутбуки и нетбуки',
          path: 'elanlar/elektronika/noutbuklar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2946,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOA',
          name: 'Оргтехника и расходники',
          path: 'elanlar/elektronika/ofis-avadanliqi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 687,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOQ',
          name: 'Мобильные телефоны',
          path: 'elanlar/elektronika/telefonlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 10690,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzOQ',
          name: 'Номера и SIM-карты',
          path: 'elanlar/elektronika/nomreler-ve-sim-kartlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1826,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMA',
          name: 'Фототехника',
          path: 'elanlar/elektronika/fotoaparatlar-ve-linzalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1039,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5MA',
          name: 'Смарт часы и браслеты',
          path: 'elanlar/elektronika/smart-saat-ve-qolbaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 959,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5MQ',
          name: 'Телевизоры и аксессуары',
          path: 'elanlar/elektronika/televizor-ve-aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1633,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNw',
          name: 'Сетевое и серверное оборудование',
          path: 'elanlar/elektronika/sebeke-avadanligi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 622,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Электроника',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
      name: 'Хобби и отдых',
      path: 'elanlar/hobbi-ve-asude',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
      __typename: 'Category',
      description:
        'Билеты и путешествия, велосипеды, коллекционирование, спорт и отдых, музыкальные инструменты, книги и журналы, знакомства, охота и рыбалка',
      count: 8519,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMg',
          name: 'Билеты и путешествия',
          path: 'elanlar/hobbi-ve-asude/turlar-ve-biletler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 70,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMw',
          name: 'Велосипеды',
          path: 'elanlar/hobbi-ve-asude/velosipedler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 3142,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNA',
          name: 'Коллекции',
          path: 'elanlar/hobbi-ve-asude/kolleksiyalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1047,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNQ',
          name: 'Музыкальные инструменты',
          path: 'elanlar/hobbi-ve-asude/musiqi-aletleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1000,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNg',
          name: 'Спорт и отдых',
          path: 'elanlar/hobbi-ve-asude/idman-ve-asude',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2109,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNw',
          name: 'Книги и журналы',
          path: 'elanlar/hobbi-ve-asude/kitab-ve-jurnallar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 629,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOA',
          name: 'Кемпинг, охота и рыбалка',
          path: 'elanlar/hobbi-ve-asude/kempinq-ovculuq-baliqciliq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 377,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNw',
          name: 'Знакомства',
          path: 'elanlar/hobbi-ve-asude/tanisliq',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 145,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Хобби и отдых',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
      name: 'Транспорт',
      path: 'elanlar/neqliyyat',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
      __typename: 'Category',
      description:
        'Автомобили, автозапчасти, аксессуары, автобусы и техника, мотоциклы, мопеды, водный транспорт, агротехника ',
      count: 27660,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mg',
          name: 'Легковые автомобили',
          path: 'elanlar/neqliyyat/avtomobiller',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 5186,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mw',
          name: 'Автозапчасти и аксессуары',
          path: 'elanlar/neqliyyat/ehtiyyat-hisseleri-ve-aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 19864,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4NA',
          name: 'Водный транспорт',
          path: 'elanlar/neqliyyat/su-neqliyyati',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 72,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4NQ',
          name: 'Мотоциклы и мопеды',
          path: 'elanlar/neqliyyat/motosikletler-mopedler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 922,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Ng',
          name: 'Строительная техника',
          path: 'elanlar/neqliyyat/tikinti-texnikasi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 289,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Nw',
          name: 'Агротехника',
          path: 'elanlar/neqliyyat/aqrotexnika',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 263,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMw',
          name: 'Автобусы',
          path: 'elanlar/neqliyyat/avtobuslar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 16,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNA',
          name: 'Грузовики и прицепы',
          path: 'elanlar/neqliyyat/yuk-masinlari-ve-qosqular',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 478,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcxMQ',
          name: 'Регистрационные номера',
          path: 'elanlar/neqliyyat/qeydiyyat-nisanlari',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 570,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Транспорт',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
      name: 'Недвижимость',
      path: 'elanlar/dasinmaz-emlak',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
      __typename: 'Category',
      description:
        'Квартиры, дома, дачи, коттеджи, земельные участки, объекты, офисы, гаражи, недвижимость за рубежом',
      count: 27368,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNQ',
          name: 'Квартиры',
          path: 'elanlar/dasinmaz-emlak/menziller',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 14257,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMQ',
          name: 'Дома, дачи, коттеджи',
          path: 'elanlar/dasinmaz-emlak/heyet-evleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 7968,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMg',
          name: 'Земельные участки',
          path: 'elanlar/dasinmaz-emlak/torpaq-sahesi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2632,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMw',
          name: 'Гаражи',
          path: 'elanlar/dasinmaz-emlak/qarajlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 76,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNA',
          name: 'Недвижимость за рубежом',
          path: 'elanlar/dasinmaz-emlak/xaricde-emlak',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 37,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNQ',
          name: 'Объекты и офисы',
          path: 'elanlar/dasinmaz-emlak/obyektler-ve-ofisler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2398,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Недвижимость',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
      name: 'Работа',
      path: 'elanlar/is-elanlari',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
      __typename: 'Category',
      description: 'Вакансии, ищу работу',
      count: 6538,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzMA',
          name: 'Работаm',
          path: 'elanlar/is-elanlari/is-elanlarim',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 0,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
            name: 'Работа',
            count: 6538,
            path: 'elanlar/is-elanlari',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4OA',
          name: 'Вакансии',
          path: 'elanlar/is-elanlari/vakansiyalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 4816,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
            name: 'Работа',
            count: 6538,
            path: 'elanlar/is-elanlari',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4OQ',
          name: 'Ищу работу',
          path: 'elanlar/is-elanlari/is-axtariram',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1722,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
            name: 'Работа',
            count: 6538,
            path: 'elanlar/is-elanlari',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
      name: 'Животные',
      path: 'elanlar/heyvanlar',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
      __typename: 'Category',
      description:
        'Собаки, кошки, птицы, аквариум и рыбы, другие животные, товары для животных',
      count: 6124,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5NA',
          name: 'Собаки',
          path: 'elanlar/heyvanlar/itler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1067,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5NQ',
          name: 'Кошки',
          path: 'elanlar/heyvanlar/pisikler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1204,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Ng',
          name: 'Птицы',
          path: 'elanlar/heyvanlar/quslar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 2068,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Nw',
          name: 'Аквариумы и рыбы',
          path: 'elanlar/heyvanlar/baliqlar-akvariumlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 371,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5OQ',
          name: 'С/Х животные',
          path: 'elanlar/heyvanlar/kt-heyvanlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 541,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMA',
          name: 'Товары для животных',
          path: 'elanlar/heyvanlar/heyvanlar-ucun-mehsullar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 635,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OA',
          name: 'Другие животные',
          path: 'elanlar/heyvanlar/diger-heyvanlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 40,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMA',
          name: 'Кролики',
          path: 'elanlar/heyvanlar/dovsanlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 113,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMQ',
          name: 'Лошади',
          path: 'elanlar/heyvanlar/atlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 46,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMg',
          name: 'Грызуны',
          path: 'elanlar/heyvanlar/gemiriciler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 39,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Животные',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
      name: 'Услуги и бизнес',
      path: 'elanlar/xidmetler',
      icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
      __typename: 'Category',
      description:
        'Аренда и установка оборудования, ремонт и строительство, установка охранных систем, реклама, дизайн и полиграфия, ремонт техники, сборка и реставрация мебели, перевод, обучение, подготовительные курсы, IT, интернет, музыка, развлечения и мероприятия, пита',
      count: 10226,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Все категории',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1OA',
          name: 'Аренда оборудования',
          path: 'elanlar/xidmetler/avadanliqin-icaresi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 239,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzMQ',
          name: 'Оборудование для бизнеса',
          path: 'elanlar/xidmetler/biznes-avadaliqi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4981,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Nw',
          name: 'Установка оборудования',
          path: 'elanlar/xidmetler/avadanliqin-qurasdirilmasi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 43,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tap.azstatic.com/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4MQ',
          name: 'Автосервис и диагностика',
          path: 'elanlar/xidmetler/avtoservis-ve-diaqnostika',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 73,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Mw',
          name: 'Няни, сиделки',
          path: 'elanlar/xidmetler/dayeler-baxicilar',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 34,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3NQ',
          name: 'Фото и видеосъёмка',
          path: 'elanlar/xidmetler/foto-ve-video-cekilis',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 41,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3NA',
          name: 'Красота, здоровье',
          path: 'elanlar/xidmetler/gozellik-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 30,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Mg',
          name: 'Юридические услуги',
          path: 'elanlar/xidmetler/huquq-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 8,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Mw',
          name: 'IT, интернет, телеком',
          path: 'elanlar/xidmetler/komputer-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 109,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNg',
          name: 'Логистика',
          path: 'elanlar/xidmetler/logistika',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 202,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2OA',
          name: 'Сборка и ремонт мебели',
          path: 'elanlar/xidmetler/sifarisle-mebel',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 93,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Mg',
          name: 'Музыка и мероприятия',
          path: 'elanlar/xidmetler/tedbirlerin-teskilati',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 42,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3OA',
          name: 'Бухгалтерские услуги',
          path: 'elanlar/xidmetler/muhasibat-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 47,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2OQ',
          name: 'Аренда транспорта',
          path: 'elanlar/xidmetler/neqliyyat-icaresi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 417,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Nw',
          name: 'Питание, кейтеринг',
          path: 'elanlar/xidmetler/keyterinq-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 57,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2NQ',
          name: 'Реклама, дизайн и полиграфия',
          path: 'elanlar/xidmetler/reklam-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 153,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Ng',
          name: 'Страхование',
          path: 'elanlar/xidmetler/sigorta-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 7,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3MQ',
          name: 'Системы безопасности',
          path: 'elanlar/xidmetler/tehlukesizlik-sistemleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 2168,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2MA',
          name: 'Обучение и курсы',
          path: 'elanlar/xidmetler/telim-hazirliq-kurslari',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 198,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Ng',
          name: 'Ремонт и строительство',
          path: 'elanlar/xidmetler/temir-tikinti',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 744,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3MA',
          name: 'Уборка',
          path: 'elanlar/xidmetler/temizlik-xidmeti',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 90,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2NA',
          name: 'Перевод',
          path: 'elanlar/xidmetler/tercume-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 17,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Nw',
          name: 'Ремонт техники',
          path: 'elanlar/xidmetler/texnika-temiri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 304,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2MQ',
          name: 'Медицинские услуги',
          path: 'elanlar/xidmetler/tibbi-xidmetler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 24,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1OQ',
          name: 'Другое',
          path: 'elanlar/xidmetler/diger-xidmetler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 105,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Услуги и бизнес',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
      ],
    },
  ],
};

const createAdCategoriesMockAz = {
  categories: [
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
      name: 'Uşaq aləmi',
      path: 'elanlar/usaqlar-ucun',
      icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
      __typename: 'Category',
      description:
        'Tap.az-da hər yaşda uşaqlar üçün axtardığınız əşyaları (oyuncaqlar, geyim, usaq belekleri və s.) tapa və ya sata bilərsiniz. Məhsullar olduqca sərfəli qiymətə təqdim olunur və qısa müddətdə alıcı tapır.',
      count: 5033,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OQ',
          name: 'Avtomobil oturacaqları',
          path: 'elanlar/usaqlar-ucun/avtomobil-oturacaqlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 125,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1MA',
          name: 'Oyuncaqlar',
          path: 'elanlar/usaqlar-ucun/oyuncaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 720,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1MQ',
          name: 'Uşaq arabaları',
          path: 'elanlar/usaqlar-ucun/usaq-arabalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 922,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Nw',
          name: 'Uşaq avtomobilləri',
          path: 'elanlar/usaqlar-ucun/usaq-avtomobilleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 337,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Mw',
          name: 'Çarpayılar və beşiklər',
          path: 'elanlar/usaqlar-ucun/usaq-carpayilari-ve-beshikler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 889,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Ng',
          name: 'Uşaq daşıyıcıları',
          path: 'elanlar/usaqlar-ucun/usaq-dasiyicilari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 60,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Mg',
          name: 'Uşaq geyimi',
          path: 'elanlar/usaqlar-ucun/usaq-geyimleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 579,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Mw',
          name: 'Uşaq mebeli',
          path: 'elanlar/usaqlar-ucun/mebel',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 273,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1NA',
          name: 'Uşaq qidası və bəslənməsi',
          path: 'elanlar/usaqlar-ucun/usaq-yemekleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 52,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4NQ',
          name: 'Sürüşkənlər və meydançalar',
          path: 'elanlar/usaqlar-ucun/usaq-suruskenleri-ve-oyun-meydancalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 65,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Mg',
          name: 'Manejlər',
          path: 'elanlar/usaqlar-ucun/manejler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 45,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3OQ',
          name: 'Məktəblilər üçün',
          path: 'elanlar/usaqlar-ucun/mekteb-levazimatlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 536,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4MA',
          name: 'Yürütəclər',
          path: 'elanlar/usaqlar-ucun/yurutecler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 106,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwOA',
          name: 'Hamam və gigiyena',
          path: 'elanlar/usaqlar-ucun/usaq-gigiyenasi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 62,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwOQ',
          name: 'Uşaq tekstili',
          path: 'elanlar/usaqlar-ucun/usaq-tekstili',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 32,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4NA',
          name: 'Qidalanma oturacaqları',
          path: 'elanlar/usaqlar-ucun/qidalanma-ucun-usaq-oturacaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 214,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1NQ',
          name: 'Digər',
          path: 'elanlar/usaqlar-ucun/her-sey',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 16,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0OA',
            name: 'Uşaq aləmi',
            count: 5033,
            path: 'elanlar/usaqlar-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/kids-world-b3b90bb08c6ce1ea30bcf85429a82c37061554d345de949024df47449637d0e8.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
      name: 'Şəxsi əşyalar',
      path: 'elanlar/sexsi-esyalar',
      icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
      __typename: 'Category',
      description:
        'Tap.az istifadəçiləri burada yeni və işlənmiş geyimlərini, aksesuarlarını və digər əşyalarını sataraq gəlir əldə edir, həmçinin itirdikləri və ya tapdıqları əşyalar barədə elanlar yerləşdirir.',
      count: 8465,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNw',
          name: 'Geyim və ayaqqabılar',
          path: 'elanlar/sexsi-esyalar/geyim-ayaqqabilar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 3632,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNg',
          name: 'Saat və zinət əşyaları',
          path: 'elanlar/sexsi-esyalar/saatlar-zinet-esyalari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1675,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwOA',
          name: 'Aksesuarlar',
          path: 'elanlar/sexsi-esyalar/aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1118,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwOQ',
          name: 'Uşaq məhsulları və oyuncaqlar',
          path: 'elanlar/sexsi-esyalar/baby-products-and-toys',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 0,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzOA',
          name: 'Sağlamlıq və gözəllik',
          path: 'elanlar/sexsi-esyalar/gozellik-saglamliq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1630,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY0Mw',
          name: 'İtmiş əşyalar',
          path: 'elanlar/sexsi-esyalar/itmis-esyalar',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 30,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5OA',
          name: 'Elektron siqaretlər və tütün qızdırıcıları',
          path: 'elanlar/sexsi-esyalar/elektron-siqaretler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 380,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMA',
            name: 'Şəxsi əşyalar',
            count: 8465,
            path: 'elanlar/sexsi-esyalar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/personal-belongings-baa3b91011c733a6e89fb1a25c788fc9bc123999a810a2b14fc3a4dc7a51626a.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
      name: 'Ev və bağ üçün',
      path: 'elanlar/ev-ve-bag-ucun',
      icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
      __typename: 'Category',
      description:
        'Təmir-tikinti üçün hər şey, mebel, yeni və islenmis ev esyalari, yeni və ikinci əl mətbəx ləvazimatları, məişət texnikası, bir sözlə, ev və bağ üçün əşyalar ilə bağlı hər şeyi burada tapa və sata bilərsiniz.',
      count: 25103,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4OA',
          name: 'Təmir və tikinti',
          path: 'elanlar/ev-ve-bag-ucun/temir-tikinti',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4756,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4OQ',
          name: 'Mebellər',
          path: 'elanlar/ev-ve-bag-ucun/mebel',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 7544,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MA',
          name: 'Məişət texnikası',
          path: 'elanlar/ev-ve-bag-ucun/meiset-texnikasi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 6621,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5MQ',
          name: 'Qab-qacaq və mətbəx ləvazimatları',
          path: 'elanlar/ev-ve-bag-ucun/qab-qacaq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1691,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzMw',
          name: 'Ərzaq',
          path: 'elanlar/ev-ve-bag-ucun/erzaq',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 276,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mg',
          name: 'Bitkilər',
          path: 'elanlar/ev-ve-bag-ucun/bitkiler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 575,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Mg',
          name: 'Xalçalar və aksesuarlar',
          path: 'elanlar/ev-ve-bag-ucun/xalcalar-aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 594,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Mw',
          name: 'Ev tekstili',
          path: 'elanlar/ev-ve-bag-ucun/ev-tekstili',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 439,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5NA',
          name: 'Ev və bağ üçün işiqlandırma',
          path: 'elanlar/ev-ve-bag-ucun/ev-bag-ucun-ishiqlandirma',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 609,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5NQ',
          name: 'Dekor və interyer',
          path: 'elanlar/ev-ve-bag-ucun/dekor-interyer',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 936,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5Ng',
          name: 'Bağ və bostan',
          path: 'elanlar/ev-ve-bag-ucun/bag-bostan',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 849,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNQ',
          name: 'Ev təsərrüfatı malları',
          path: 'elanlar/ev-ve-bag-ucun/ev-teserrufati-mallari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 213,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Mw',
            name: 'Ev və bağ üçün',
            count: 25103,
            path: 'elanlar/ev-ve-bag-ucun',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/house-and-cottage-bb03b23b13b2cdf1301f6914501c2a6d180baf510b7e9d28aa5f32c22c88cfee.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
      name: 'Elektronika',
      path: 'elanlar/elektronika',
      icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
      __typename: 'Category',
      description:
        'Tap.az telefonlar və planşetlərdən çeşidli aksesuarlara qədər hər növ yeni və işlənmiş elektronika məhsulları üzrə çox sərfəli təkliflərin ünvanıdır – həm alıcılar, həm də satıcılar üçün sərfəli.',
      count: 28479,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMQ',
          name: 'Audio və video',
          path: 'elanlar/elektronika/audio-video',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1632,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMg',
          name: 'Kompüter aksesuarları',
          path: 'elanlar/elektronika/komputer-aksesuarlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 907,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxMw',
          name: 'Oyunlar, pultlar və proqramlar',
          path: 'elanlar/elektronika/oyunlar-ve-programlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2098,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNA',
          name: 'Masaüstü kompüterlər',
          path: 'elanlar/elektronika/komputerler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 814,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNQ',
          name: 'Komponentlər və monitorlar',
          path: 'elanlar/elektronika/komputer-avadanliqi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1902,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNg',
          name: 'Planşet və elektron kitablar',
          path: 'elanlar/elektronika/plansetler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 724,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxNw',
          name: 'Noutbuklar və netbuklar',
          path: 'elanlar/elektronika/noutbuklar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2946,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOA',
          name: 'Ofis avadanlığı və istehlak materialları',
          path: 'elanlar/elektronika/ofis-avadanliqi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 687,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYxOQ',
          name: 'Telefonlar',
          path: 'elanlar/elektronika/telefonlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 10690,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzOQ',
          name: 'Nömrələr və SIM-kartlar',
          path: 'elanlar/elektronika/nomreler-ve-sim-kartlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1826,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMA',
          name: 'Fototexnika',
          path: 'elanlar/elektronika/fotoaparatlar-ve-linzalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1039,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5MA',
          name: 'Smart saat və qolbaqlar',
          path: 'elanlar/elektronika/smart-saat-ve-qolbaqlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 959,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5MQ',
          name: 'Televizorlar və aksesuarlar',
          path: 'elanlar/elektronika/televizor-ve-aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1633,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNw',
          name: 'Şəbəkə və server avadanlığı',
          path: 'elanlar/elektronika/sebeke-avadanligi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 622,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMQ',
            name: 'Elektronika',
            count: 28479,
            path: 'elanlar/elektronika',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/consumer-electronics-20462167b14b85cb156e03c44ad6df27b4771847099c28119bfa85e8288a400e.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
      name: 'Hobbi və asudə',
      path: 'elanlar/hobbi-ve-asude',
      icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
      __typename: 'Category',
      description:
        'Asudə vaxtınızda məşğul olmaq üçün maraqlı hobbi axtarırsınız? Yaxın həftələrdə səyahətə çıxmaq istəyirsiniz? Bəs ürəyinizə yatan bir insanla tanış olmaq necə? Elədirsə, bura tam sizlikdir.',
      count: 8519,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMg',
          name: 'Biletlər və səyahət',
          path: 'elanlar/hobbi-ve-asude/turlar-ve-biletler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 70,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyMw',
          name: 'Velosipedlər',
          path: 'elanlar/hobbi-ve-asude/velosipedler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 3142,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNA',
          name: 'Kolleksiyalar',
          path: 'elanlar/hobbi-ve-asude/kolleksiyalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1047,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNQ',
          name: 'Musiqi alətləri',
          path: 'elanlar/hobbi-ve-asude/musiqi-aletleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 1000,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNg',
          name: 'İdman və asudə',
          path: 'elanlar/hobbi-ve-asude/idman-ve-asude',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2109,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyNw',
          name: 'Kitab və jurnallar',
          path: 'elanlar/hobbi-ve-asude/kitab-ve-jurnallar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 629,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOA',
          name: 'Kempinq, ovçuluq və balıqçılıq',
          path: 'elanlar/hobbi-ve-asude/kempinq-ovculuq-baliqciliq',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 377,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNw',
          name: 'Tanışlıq',
          path: 'elanlar/hobbi-ve-asude/tanisliq',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 145,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYyOQ',
            name: 'Hobbi və asudə',
            count: 8519,
            path: 'elanlar/hobbi-ve-asude',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/hobby-leisure-9af0e05040b6294be441836a80bdae173b2a0e5b4f7058d50e55cb39ebb8a554.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
      name: 'Nəqliyyat',
      path: 'elanlar/neqliyyat',
      icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
      __typename: 'Category',
      description:
        'Tap.az avtomobil almaq və ya satmaq istəyənləri bir araya gətirir. Yeni və sürülmüş nəqliyyat vasitələrini, avtomobillər üçün ehtiyat hissə və aksesuarları əla qiymətlərlə alın və ya satın.',
      count: 27660,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mg',
          name: 'Avtomobillər',
          path: 'elanlar/neqliyyat/avtomobiller',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 5186,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Mw',
          name: 'Ehtiyat hissələri və aksesuarlar',
          path: 'elanlar/neqliyyat/ehtiyyat-hisseleri-ve-aksesuarlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 19864,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4NA',
          name: 'Su nəqliyyatı',
          path: 'elanlar/neqliyyat/su-neqliyyati',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 72,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4NQ',
          name: 'Motosikletlər və mopedlər',
          path: 'elanlar/neqliyyat/motosikletler-mopedler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 922,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Ng',
          name: 'Tikinti texnikası',
          path: 'elanlar/neqliyyat/tikinti-texnikasi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 289,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4Nw',
          name: 'Aqrotexnika',
          path: 'elanlar/neqliyyat/aqrotexnika',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 263,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMw',
          name: 'Avtobuslar',
          path: 'elanlar/neqliyyat/avtobuslar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 16,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNA',
          name: 'Yük maşınları və qoşqular',
          path: 'elanlar/neqliyyat/yuk-masinlari-ve-qosqular',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 478,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcxMQ',
          name: 'Qeydiyyat nişanları',
          path: 'elanlar/neqliyyat/qeydiyyat-nisanlari',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 570,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4Nw',
            name: 'Nəqliyyat',
            count: 27660,
            path: 'elanlar/neqliyyat',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/transport-a22b4ee9344848b76ba1329b43367be937c7839817ad5e8bbe26ee7a5c55ba4f.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
      name: 'Daşınmaz əmlak',
      path: 'elanlar/dasinmaz-emlak',
      icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
      __typename: 'Category',
      description:
        'Tap.az ev alqı satqısı, eləcə də kiraye ev elanları yerləşdirmək və tapmaq üçün ideal məkandır. Burada hər növ daşınmaz əmlakı (mənzillər, evler, ofislər və s.) rahatlıqla ala və ya qısa vaxtda sata bilərsiniz.',
      count: 27368,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNQ',
          name: 'Mənzillər',
          path: 'elanlar/dasinmaz-emlak/menziller',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 14257,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMQ',
          name: 'Həyət evləri, bağ evləri',
          path: 'elanlar/dasinmaz-emlak/heyet-evleri',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 7968,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMg',
          name: 'Torpaq',
          path: 'elanlar/dasinmaz-emlak/torpaq-sahesi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2632,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMw',
          name: 'Qarajlar',
          path: 'elanlar/dasinmaz-emlak/qarajlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 76,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNA',
          name: 'Xaricdə əmlak',
          path: 'elanlar/dasinmaz-emlak/xaricde-emlak',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 37,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNQ',
          name: 'Obyektlər və ofislər',
          path: 'elanlar/dasinmaz-emlak/obyektler-ve-ofisler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 2398,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwNg',
            name: 'Daşınmaz əmlak',
            count: 27368,
            path: 'elanlar/dasinmaz-emlak',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/real-estate-7c645372591496070816f689b9d4898154393fa0119a41acc0d4482c6036ae14.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
      name: 'İş elanları',
      path: 'elanlar/is-elanlari',
      icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
      __typename: 'Category',
      description:
        'Tap.az hər zaman olduğu kimi iş var və ya is axtariram deyənlərin işini asanlaşdırır. Yeni is elanlari 2022 mövsümü üzrə daim yenilənir, yüzlərlə şəxs isə qısa zamanda axtardığı vakansiyalar üzrə iş tapır.',
      count: 6538,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzMA',
          name: 'İş elanlarım',
          path: 'elanlar/is-elanlari/is-elanlarim',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: true,
          __typename: 'Category',
          count: 0,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
            name: 'İş elanları',
            count: 6538,
            path: 'elanlar/is-elanlari',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4OA',
          name: 'Vakansiyalar',
          path: 'elanlar/is-elanlari/vakansiyalar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 4816,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
            name: 'İş elanları',
            count: 6538,
            path: 'elanlar/is-elanlari',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4OQ',
          name: 'İş axtarıram',
          path: 'elanlar/is-elanlari/is-axtariram',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1722,
          hasAutogeneratedTitle: true,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzNA',
            name: 'İş elanları',
            count: 6538,
            path: 'elanlar/is-elanlari',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/work-and-business-846e5b1fbbce52f9fa1bf425eb22e7f73944e2e2d5e90577144c78702303f7a4.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
      name: 'Heyvanlar',
      path: 'elanlar/heyvanlar',
      icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
      __typename: 'Category',
      description:
        'Tap.az müxtəlif heyvanlar üçün yeni sahib tapmaqda və ya onlara sahiblənməkdə sizə yardımçı olacaq. Burada axtardığınız heyvan növlərini, onlar üçün müxtəlif qida, əşya və oyuncaqları tapa bilərsiniz.',
      count: 6124,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5NA',
          name: 'İtlər',
          path: 'elanlar/heyvanlar/itler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1067,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5NQ',
          name: 'Pişiklər',
          path: 'elanlar/heyvanlar/pisikler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 1204,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Ng',
          name: 'Quşlar',
          path: 'elanlar/heyvanlar/quslar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 2068,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5Nw',
          name: 'Akvariumlar və balıqlar',
          path: 'elanlar/heyvanlar/baliqlar-akvariumlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 371,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY5OQ',
          name: 'K/t heyvanları',
          path: 'elanlar/heyvanlar/kt-heyvanlari',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 541,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYwMA',
          name: 'Heyvanlar üçün məhsullar',
          path: 'elanlar/heyvanlar/heyvanlar-ucun-mehsullar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 635,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OA',
          name: 'Digər heyvanlar',
          path: 'elanlar/heyvanlar/diger-heyvanlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 40,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMA',
          name: 'Dovşanlar',
          path: 'elanlar/heyvanlar/dovsanlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 113,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMQ',
          name: 'Atlar',
          path: 'elanlar/heyvanlar/atlar',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 46,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwMg',
          name: 'Gəmiricilər',
          path: 'elanlar/heyvanlar/gemiriciler',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: false,
          __typename: 'Category',
          count: 39,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU5OQ',
            name: 'Heyvanlar',
            count: 6124,
            path: 'elanlar/heyvanlar',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/animals-6fc2cb8eca9132da850bbde5ff3f414d5c55d79eb466ab4465fbcb5a7ea4afd7.png',
            __typename: 'Category',
          },
        },
      ],
    },
    {
      id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
      name: 'Xidmətlər və biznes',
      path: 'elanlar/xidmetler',
      icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
      __typename: 'Category',
      description:
        'Tap.az-da təqdim olunan çoxsaylı xidmətlərdən (elektrik, fotoqraf, repetitor və s.) yararlana və ya mütəxəssisi olduğunuz sahə üzrə xidmətlərinizi təklif edərək davamlı qazanc əldə edə bilərsiniz.',
      count: 10226,
      propertyOptions: null,
      parent: {
        id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzU4MQ',
        name: 'Bütün kateqoriyalar',
        path: 'elanlar',
        icon: null,
        __typename: 'Category',
        count: 153515,
      },
      children: [
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1OA',
          name: 'Avadanlığın icarəsi',
          path: 'elanlar/xidmetler/avadanliqin-icaresi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 239,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzYzMQ',
          name: 'Biznes üçün avadanlıq',
          path: 'elanlar/xidmetler/biznes-avadaliqi',
          isPhotoRequiredOnCreate: true,
          isPriceRequired: true,
          __typename: 'Category',
          count: 4981,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Nw',
          name: 'Avadanlıqların quraşdırılması',
          path: 'elanlar/xidmetler/avadanliqin-qurasdirilmasi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 43,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY4MQ',
          name: 'Avtoservis və diaqnostika ',
          path: 'elanlar/xidmetler/avtoservis-ve-diaqnostika',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 73,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Mw',
          name: 'Dayələr, baxıcılar',
          path: 'elanlar/xidmetler/dayeler-baxicilar',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 34,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3NQ',
          name: 'Foto və video çəkiliş xidmətləri',
          path: 'elanlar/xidmetler/foto-ve-video-cekilis',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 41,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3NA',
          name: 'Gözəllik, sağlamlıq',
          path: 'elanlar/xidmetler/gozellik-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 30,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Mg',
          name: 'Hüquq xidmətləri',
          path: 'elanlar/xidmetler/huquq-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 8,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Mw',
          name: 'IT, internet, telekom',
          path: 'elanlar/xidmetler/komputer-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 109,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzcwNg',
          name: 'Logistika',
          path: 'elanlar/xidmetler/logistika',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 202,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2OA',
          name: 'Mebel yığılması və təmiri',
          path: 'elanlar/xidmetler/sifarisle-mebel',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 93,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Mg',
          name: 'Musiqi, əyləncə və tədbirlər',
          path: 'elanlar/xidmetler/tedbirlerin-teskilati',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 42,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3OA',
          name: 'Mühasibat xidmətləri',
          path: 'elanlar/xidmetler/muhasibat-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 47,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2OQ',
          name: 'Nəqliyyat vasitələrinin icarəsi',
          path: 'elanlar/xidmetler/neqliyyat-icaresi',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 417,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Nw',
          name: 'Qidalanma, keyterinq',
          path: 'elanlar/xidmetler/keyterinq-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 57,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2NQ',
          name: 'Reklam, dizayn və poliqrafiya',
          path: 'elanlar/xidmetler/reklam-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 153,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3Ng',
          name: 'Sığorta xidmətləri',
          path: 'elanlar/xidmetler/sigorta-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 7,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3MQ',
          name: 'Təhlükəsizlik sistemləri',
          path: 'elanlar/xidmetler/tehlukesizlik-sistemleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 2168,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2MA',
          name: 'Təlim, hazırlıq kursları',
          path: 'elanlar/xidmetler/telim-hazirliq-kurslari',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 198,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Ng',
          name: 'Təmir və tikinti',
          path: 'elanlar/xidmetler/temir-tikinti',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 744,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY3MA',
          name: 'Təmizlik',
          path: 'elanlar/xidmetler/temizlik-xidmeti',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 90,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2NA',
          name: 'Tərcümə',
          path: 'elanlar/xidmetler/tercume-xidmetleri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 17,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2Nw',
          name: 'Texnika təmiri',
          path: 'elanlar/xidmetler/texnika-temiri',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 304,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY2MQ',
          name: 'Tibbi xidmətlər',
          path: 'elanlar/xidmetler/tibbi-xidmetler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 24,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
        {
          id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1OQ',
          name: 'Digər',
          path: 'elanlar/xidmetler/diger-xidmetler',
          isPhotoRequiredOnCreate: false,
          isPriceRequired: false,
          __typename: 'Category',
          count: 105,
          hasAutogeneratedTitle: false,
          parent: {
            id: 'Z2lkOi8vdGFwL0NhdGVnb3J5LzY1Ng',
            name: 'Xidmətlər və biznes',
            count: 10226,
            path: 'elanlar/xidmetler',
            icon: 'https://tapaz-create-ad.azstaging.net/assets/shared/categories-raster/services-abd07952c66587dff54eee91d0d8668b919fc923249882ff53bae02578ef2cb4.png',
            __typename: 'Category',
          },
        },
      ],
    },
  ],
};

export const createAdCategoriesMock = (locale: string) =>
  locale === 'ru' ? createAdCategoriesMockRu : createAdCategoriesMockAz;

export const categoriesMock = (locale: string) =>
  locale === 'ru' ? categoriesMockRu : categoriesMockAz;

export const rootCategoriesMock = (locale: string) =>
  locale === 'ru' ? rootCategoriesMockRu : rootCategoriesMockAz;
